/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  AverageCompletionTime,
  BlockContactRequest,
  BlockCustomerRequest,
  BlockOrderContactsRequest,
  BlockedContact,
  BlockedContactMatch,
  BulkDispatchRequest,
  BulkTablePositionRequest,
  CloseOrderWithoutDocumentRequest,
  ConfirmOrderStatusRequest,
  CourierBalance,
  CourierOffer,
  CourierOrder,
  CourierSettlementRequest,
  CreateOrderRequest,
  CreateRestaurantTableRequest,
  CreateRestaurantZoneRequest,
  CustomerBlock,
  DailySummary,
  DelaySmsSent,
  DeleteRestaurantTablesTableIdParams,
  DeleteRestaurantZonesZoneId200,
  DeliveryQuote,
  DeliveryRun,
  DeliveryZone,
  DeliveryZoneRequest,
  DepotResponse,
  DoorTransferState,
  GetBlockedContactsMatchParams,
  GetDeliveryQuoteParams,
  GetKitchenCallsParams,
  GetOrdersDailySummaryParams,
  GetOrdersHeatmapParams,
  GetOrdersParams,
  GetTripLogParams,
  GetVehiclesParams,
  KitchenCall,
  KitchenCallRequest,
  KitchenCalls,
  KitchenProgressLine,
  KitchenProgressRequest,
  Order,
  OrderChannelMoved,
  OrderClosedWithoutDocument,
  OrderEditLog,
  OrderFull,
  OrderHeatmap,
  OrderList,
  OrderReturnedToKitchen,
  OrderStatusConfirmed,
  OrderStatusLog,
  OrderTab,
  OrderTabDetail,
  OrdersDispatched,
  OrdersReset,
  PatchOrdersOrderIdBody,
  PatchOrdersOrderIdSalesChannelBody,
  PatchRestaurantTablesTableId200,
  PatchSalesChannelsIdBody,
  PatchVehiclesVehicleIdBody,
  PostOrderTabsBody,
  PostOrderTabsIdSettleBody,
  PostRestaurantTables200,
  PostSalesChannelsBody,
  PostVehiclesBody,
  PublicSalesChannel,
  RestaurantTableList,
  RestaurantZone,
  RestaurantZoneList,
  ReturnOrderToKitchenRequest,
  SalesChannel,
  SalesChannelDeleted,
  ServedLine,
  ServedStatusRequest,
  SplitPaymentRequest,
  SplitPaymentResult,
  TableDeleted,
  TablePointsApplied,
  TablePointsCodeRequest,
  TablePointsOnTheBill,
  TablePointsQuote,
  TablePointsSpendRequest,
  TablePointsState,
  TablePositionsSaved,
  UpdateRestaurantTableRequest,
  UpdateRestaurantZoneRequest,
  Vehicle,
  VehicleDeleted,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutRestaurantTablesBulkUrl = () => {
  return `/api/v1/restaurant-tables/bulk`
}

/**
 * @summary Apply a batch of position changes from the plan editor
 */
export const putRestaurantTablesBulk = async (
  bulkTablePositionRequest: BulkTablePositionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<TablePositionsSaved> => {
  return customFetch<TablePositionsSaved>(getPutRestaurantTablesBulkUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkTablePositionRequest),
  })
}

export const getPutRestaurantTablesBulkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putRestaurantTablesBulk>>,
    TError,
    { data: BulkTablePositionRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putRestaurantTablesBulk>>,
  TError,
  { data: BulkTablePositionRequest },
  TContext
> => {
  const mutationKey = ['putRestaurantTablesBulk']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putRestaurantTablesBulk>>,
    { data: BulkTablePositionRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putRestaurantTablesBulk(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutRestaurantTablesBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof putRestaurantTablesBulk>>
>
export type PutRestaurantTablesBulkMutationBody = BulkTablePositionRequest
export type PutRestaurantTablesBulkMutationError = unknown

/**
 * @summary Apply a batch of position changes from the plan editor
 */
export const usePutRestaurantTablesBulk = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putRestaurantTablesBulk>>,
      TError,
      { data: BulkTablePositionRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putRestaurantTablesBulk>>,
  TError,
  { data: BulkTablePositionRequest },
  TContext
> => {
  return useMutation(getPutRestaurantTablesBulkMutationOptions(options), queryClient)
}
export const getGetDeliveryZonesUrl = () => {
  return `/api/v1/delivery-zones`
}

/**
 * @summary List delivery zones (public)
 */
export const getDeliveryZones = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DeliveryZone[]> => {
  return customFetch<DeliveryZone[]>(getGetDeliveryZonesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetDeliveryZonesQueryKey = () => {
  return [`/api/v1/delivery-zones`] as const
}

export const getGetDeliveryZonesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliveryZones>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZones>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDeliveryZonesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeliveryZones>>> = ({ signal }) =>
    getDeliveryZones({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliveryZones>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeliveryZonesQueryResult = NonNullable<Awaited<ReturnType<typeof getDeliveryZones>>>
export type GetDeliveryZonesQueryError = unknown

export function useGetDeliveryZones<
  TData = Awaited<ReturnType<typeof getDeliveryZones>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZones>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryZones>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryZones>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryZones<
  TData = Awaited<ReturnType<typeof getDeliveryZones>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZones>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryZones>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryZones>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryZones<
  TData = Awaited<ReturnType<typeof getDeliveryZones>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZones>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List delivery zones (public)
 */

export function useGetDeliveryZones<
  TData = Awaited<ReturnType<typeof getDeliveryZones>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZones>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDeliveryZonesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutDeliveryZonesUrl = () => {
  return `/api/v1/delivery-zones`
}

/**
 * @summary Replace every delivery zone
 */
export const putDeliveryZones = async (
  deliveryZoneRequest: DeliveryZoneRequest[],
  options?: Parameters<typeof customFetch>[1],
): Promise<DeliveryZone[]> => {
  return customFetch<DeliveryZone[]>(getPutDeliveryZonesUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deliveryZoneRequest),
  })
}

export const getPutDeliveryZonesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putDeliveryZones>>,
    TError,
    { data: DeliveryZoneRequest[] },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putDeliveryZones>>,
  TError,
  { data: DeliveryZoneRequest[] },
  TContext
> => {
  const mutationKey = ['putDeliveryZones']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putDeliveryZones>>,
    { data: DeliveryZoneRequest[] }
  > = (props) => {
    const { data } = props ?? {}

    return putDeliveryZones(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutDeliveryZonesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putDeliveryZones>>
>
export type PutDeliveryZonesMutationBody = DeliveryZoneRequest[]
export type PutDeliveryZonesMutationError = unknown

/**
 * @summary Replace every delivery zone
 */
export const usePutDeliveryZones = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putDeliveryZones>>,
      TError,
      { data: DeliveryZoneRequest[] },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putDeliveryZones>>,
  TError,
  { data: DeliveryZoneRequest[] },
  TContext
> => {
  return useMutation(getPutDeliveryZonesMutationOptions(options), queryClient)
}
export const getGetVehiclesUrl = (params?: GetVehiclesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/vehicles?${stringifiedParams}` : `/api/v1/vehicles`
}

/**
 * @summary List vehicles with their delivery mileage
 */
export const getVehicles = async (
  params?: GetVehiclesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Vehicle[]> => {
  return customFetch<Vehicle[]>(getGetVehiclesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetVehiclesQueryKey = (params?: GetVehiclesParams) => {
  return [`/api/v1/vehicles`, ...(params ? [params] : [])] as const
}

export const getGetVehiclesQueryOptions = <
  TData = Awaited<ReturnType<typeof getVehicles>>,
  TError = unknown,
>(
  params?: GetVehiclesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetVehiclesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicles>>> = ({ signal }) =>
    getVehicles(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVehicles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicles>>>
export type GetVehiclesQueryError = unknown

export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = unknown>(
  params: undefined | GetVehiclesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicles>>,
          TError,
          Awaited<ReturnType<typeof getVehicles>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = unknown>(
  params?: GetVehiclesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicles>>,
          TError,
          Awaited<ReturnType<typeof getVehicles>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = unknown>(
  params?: GetVehiclesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List vehicles with their delivery mileage
 */

export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = unknown>(
  params?: GetVehiclesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetVehiclesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostVehiclesUrl = () => {
  return `/api/v1/vehicles`
}

/**
 * @summary Add a vehicle
 */
export const postVehicles = async (
  postVehiclesBody: PostVehiclesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Vehicle> => {
  return customFetch<Vehicle>(getPostVehiclesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postVehiclesBody),
  })
}

export const getPostVehiclesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postVehicles>>,
    TError,
    { data: PostVehiclesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postVehicles>>,
  TError,
  { data: PostVehiclesBody },
  TContext
> => {
  const mutationKey = ['postVehicles']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postVehicles>>,
    { data: PostVehiclesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postVehicles(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostVehiclesMutationResult = NonNullable<Awaited<ReturnType<typeof postVehicles>>>
export type PostVehiclesMutationBody = PostVehiclesBody
export type PostVehiclesMutationError = unknown

/**
 * @summary Add a vehicle
 */
export const usePostVehicles = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postVehicles>>,
      TError,
      { data: PostVehiclesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postVehicles>>,
  TError,
  { data: PostVehiclesBody },
  TContext
> => {
  return useMutation(getPostVehiclesMutationOptions(options), queryClient)
}
export const getGetSalesChannelsUrl = () => {
  return `/api/v1/sales-channels`
}

/**
 * @summary Every sales channel and what it is capable of
 */
export const getSalesChannels = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<SalesChannel[]> => {
  return customFetch<SalesChannel[]>(getGetSalesChannelsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSalesChannelsQueryKey = () => {
  return [`/api/v1/sales-channels`] as const
}

export const getGetSalesChannelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesChannels>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannels>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSalesChannelsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesChannels>>> = ({ signal }) =>
    getSalesChannels({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesChannels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSalesChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesChannels>>>
export type GetSalesChannelsQueryError = unknown

export function useGetSalesChannels<
  TData = Awaited<ReturnType<typeof getSalesChannels>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannels>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesChannels>>,
          TError,
          Awaited<ReturnType<typeof getSalesChannels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesChannels<
  TData = Awaited<ReturnType<typeof getSalesChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannels>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesChannels>>,
          TError,
          Awaited<ReturnType<typeof getSalesChannels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesChannels<
  TData = Awaited<ReturnType<typeof getSalesChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannels>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every sales channel and what it is capable of
 */

export function useGetSalesChannels<
  TData = Awaited<ReturnType<typeof getSalesChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannels>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSalesChannelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSalesChannelsUrl = () => {
  return `/api/v1/sales-channels`
}

/**
 * @summary Create a sales channel
 */
export const postSalesChannels = async (
  postSalesChannelsBody: PostSalesChannelsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SalesChannel> => {
  return customFetch<SalesChannel>(getPostSalesChannelsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSalesChannelsBody),
  })
}

export const getPostSalesChannelsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSalesChannels>>,
    TError,
    { data: PostSalesChannelsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSalesChannels>>,
  TError,
  { data: PostSalesChannelsBody },
  TContext
> => {
  const mutationKey = ['postSalesChannels']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSalesChannels>>,
    { data: PostSalesChannelsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSalesChannels(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSalesChannelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSalesChannels>>
>
export type PostSalesChannelsMutationBody = PostSalesChannelsBody
export type PostSalesChannelsMutationError = unknown

/**
 * @summary Create a sales channel
 */
export const usePostSalesChannels = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSalesChannels>>,
      TError,
      { data: PostSalesChannelsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSalesChannels>>,
  TError,
  { data: PostSalesChannelsBody },
  TContext
> => {
  return useMutation(getPostSalesChannelsMutationOptions(options), queryClient)
}
export const getGetRestaurantZonesUrl = () => {
  return `/api/v1/restaurant-zones`
}

/**
 * @summary The zones the dining room is divided into
 */
export const getRestaurantZones = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<RestaurantZoneList> => {
  return customFetch<RestaurantZoneList>(getGetRestaurantZonesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetRestaurantZonesQueryKey = () => {
  return [`/api/v1/restaurant-zones`] as const
}

export const getGetRestaurantZonesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRestaurantZones>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRestaurantZones>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRestaurantZonesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRestaurantZones>>> = ({ signal }) =>
    getRestaurantZones({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRestaurantZones>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRestaurantZonesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRestaurantZones>>
>
export type GetRestaurantZonesQueryError = unknown

export function useGetRestaurantZones<
  TData = Awaited<ReturnType<typeof getRestaurantZones>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRestaurantZones>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRestaurantZones>>,
          TError,
          Awaited<ReturnType<typeof getRestaurantZones>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRestaurantZones<
  TData = Awaited<ReturnType<typeof getRestaurantZones>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRestaurantZones>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRestaurantZones>>,
          TError,
          Awaited<ReturnType<typeof getRestaurantZones>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRestaurantZones<
  TData = Awaited<ReturnType<typeof getRestaurantZones>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRestaurantZones>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The zones the dining room is divided into
 */

export function useGetRestaurantZones<
  TData = Awaited<ReturnType<typeof getRestaurantZones>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRestaurantZones>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRestaurantZonesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostRestaurantZonesUrl = () => {
  return `/api/v1/restaurant-zones`
}

/**
 * @summary Add a zone
 */
export const postRestaurantZones = async (
  createRestaurantZoneRequest: CreateRestaurantZoneRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RestaurantZone> => {
  return customFetch<RestaurantZone>(getPostRestaurantZonesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRestaurantZoneRequest),
  })
}

export const getPostRestaurantZonesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRestaurantZones>>,
    TError,
    { data: CreateRestaurantZoneRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRestaurantZones>>,
  TError,
  { data: CreateRestaurantZoneRequest },
  TContext
> => {
  const mutationKey = ['postRestaurantZones']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRestaurantZones>>,
    { data: CreateRestaurantZoneRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postRestaurantZones(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRestaurantZonesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRestaurantZones>>
>
export type PostRestaurantZonesMutationBody = CreateRestaurantZoneRequest
export type PostRestaurantZonesMutationError = unknown

/**
 * @summary Add a zone
 */
export const usePostRestaurantZones = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRestaurantZones>>,
      TError,
      { data: CreateRestaurantZoneRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRestaurantZones>>,
  TError,
  { data: CreateRestaurantZoneRequest },
  TContext
> => {
  return useMutation(getPostRestaurantZonesMutationOptions(options), queryClient)
}
export const getGetRestaurantTablesUrl = () => {
  return `/api/v1/restaurant-tables`
}

/**
 * @summary The floor plan (public)
 */
export const getRestaurantTables = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<RestaurantTableList> => {
  return customFetch<RestaurantTableList>(getGetRestaurantTablesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetRestaurantTablesQueryKey = () => {
  return [`/api/v1/restaurant-tables`] as const
}

export const getGetRestaurantTablesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRestaurantTables>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRestaurantTables>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRestaurantTablesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRestaurantTables>>> = ({ signal }) =>
    getRestaurantTables({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRestaurantTables>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRestaurantTablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRestaurantTables>>
>
export type GetRestaurantTablesQueryError = unknown

export function useGetRestaurantTables<
  TData = Awaited<ReturnType<typeof getRestaurantTables>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRestaurantTables>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRestaurantTables>>,
          TError,
          Awaited<ReturnType<typeof getRestaurantTables>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRestaurantTables<
  TData = Awaited<ReturnType<typeof getRestaurantTables>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRestaurantTables>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRestaurantTables>>,
          TError,
          Awaited<ReturnType<typeof getRestaurantTables>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRestaurantTables<
  TData = Awaited<ReturnType<typeof getRestaurantTables>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRestaurantTables>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The floor plan (public)
 */

export function useGetRestaurantTables<
  TData = Awaited<ReturnType<typeof getRestaurantTables>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRestaurantTables>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRestaurantTablesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostRestaurantTablesUrl = () => {
  return `/api/v1/restaurant-tables`
}

/**
 * @summary Add a table to the plan
 */
export const postRestaurantTables = async (
  createRestaurantTableRequest: CreateRestaurantTableRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostRestaurantTables200> => {
  return customFetch<PostRestaurantTables200>(getPostRestaurantTablesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRestaurantTableRequest),
  })
}

export const getPostRestaurantTablesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRestaurantTables>>,
    TError,
    { data: CreateRestaurantTableRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRestaurantTables>>,
  TError,
  { data: CreateRestaurantTableRequest },
  TContext
> => {
  const mutationKey = ['postRestaurantTables']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRestaurantTables>>,
    { data: CreateRestaurantTableRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postRestaurantTables(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRestaurantTablesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRestaurantTables>>
>
export type PostRestaurantTablesMutationBody = CreateRestaurantTableRequest
export type PostRestaurantTablesMutationError = unknown

/**
 * @summary Add a table to the plan
 */
export const usePostRestaurantTables = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRestaurantTables>>,
      TError,
      { data: CreateRestaurantTableRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRestaurantTables>>,
  TError,
  { data: CreateRestaurantTableRequest },
  TContext
> => {
  return useMutation(getPostRestaurantTablesMutationOptions(options), queryClient)
}
export const getGetOrdersUrl = (params?: GetOrdersParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/orders?${stringifiedParams}` : `/api/v1/orders`
}

/**
 * @summary The order board, filtered and paged
 */
export const getOrders = async (
  params?: GetOrdersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderList> => {
  return customFetch<OrderList>(getGetOrdersUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersQueryKey = (params?: GetOrdersParams) => {
  return [`/api/v1/orders`, ...(params ? [params] : [])] as const
}

export const getGetOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = unknown,
>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrders>>> = ({ signal }) =>
    getOrders(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrders>>>
export type GetOrdersQueryError = unknown

export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
  params: undefined | GetOrdersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrders>>,
          TError,
          Awaited<ReturnType<typeof getOrders>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrders>>,
          TError,
          Awaited<ReturnType<typeof getOrders>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The order board, filtered and paged
 */

export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostOrdersUrl = () => {
  return `/api/v1/orders`
}

/**
 * @summary Place an order
 */
export const postOrders = async (
  createOrderRequest: CreateOrderRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Order> => {
  return customFetch<Order>(getPostOrdersUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrderRequest),
  })
}

export const getPostOrdersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrders>>,
    TError,
    { data: CreateOrderRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrders>>,
  TError,
  { data: CreateOrderRequest },
  TContext
> => {
  const mutationKey = ['postOrders']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrders>>,
    { data: CreateOrderRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postOrders(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof postOrders>>>
export type PostOrdersMutationBody = CreateOrderRequest
export type PostOrdersMutationError = unknown

/**
 * @summary Place an order
 */
export const usePostOrders = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrders>>,
      TError,
      { data: CreateOrderRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrders>>,
  TError,
  { data: CreateOrderRequest },
  TContext
> => {
  return useMutation(getPostOrdersMutationOptions(options), queryClient)
}
export const getGetOrdersOrderIdTransferPaymentUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/transfer-payment`
}

/**
 * Cheap: a row read, not a call to the gateway. The gateway's own notification settles the payment, so a transfer that lands in one minute is reported in one minute.
 *
 * Reading this is what applies the deadline and what closes a paid order, so the driver's poll and the scheduled sweep take the same path.
 * @summary What became of the transfer, and what the order is now
 */
export const getOrdersOrderIdTransferPayment = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DoorTransferState> => {
  return customFetch<DoorTransferState>(getGetOrdersOrderIdTransferPaymentUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersOrderIdTransferPaymentQueryKey = (orderId: number) => {
  return [`/api/v1/orders/${orderId}/transfer-payment`] as const
}

export const getGetOrdersOrderIdTransferPaymentQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersOrderIdTransferPaymentQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>> = ({
    signal,
  }) => getOrdersOrderIdTransferPayment(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrdersOrderIdTransferPaymentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>
>
export type GetOrdersOrderIdTransferPaymentQueryError = unknown

export function useGetOrdersOrderIdTransferPayment<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdTransferPayment<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdTransferPayment<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What became of the transfer, and what the order is now
 */

export function useGetOrdersOrderIdTransferPayment<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdTransferPayment>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersOrderIdTransferPaymentQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostOrdersOrderIdTransferPaymentUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/transfer-payment`
}

/**
 * Returns at once with the gateway's page URL, which is what the driver renders as a QR. Nothing blocks: the ten-minute deadline is compared against the payment row on every read of the endpoint below.
 *
 * Pressing this twice returns the transfer already open rather than creating a second session - two sessions for one order is two payments the archive cannot reconcile against one delivery.
 * @summary Open a bank transfer for this order, through the card gateway
 */
export const postOrdersOrderIdTransferPayment = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DoorTransferState> => {
  return customFetch<DoorTransferState>(getPostOrdersOrderIdTransferPaymentUrl(orderId), {
    ...options,
    method: 'POST',
  })
}

export const getPostOrdersOrderIdTransferPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdTransferPayment>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdTransferPayment>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdTransferPayment']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdTransferPayment>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return postOrdersOrderIdTransferPayment(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdTransferPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdTransferPayment>>
>

export type PostOrdersOrderIdTransferPaymentMutationError = unknown

/**
 * @summary Open a bank transfer for this order, through the card gateway
 */
export const usePostOrdersOrderIdTransferPayment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdTransferPayment>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdTransferPayment>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdTransferPaymentMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdSendDelaySmsUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/send-delay-sms`
}

/**
 * @summary Send the running-late text for one order, by hand
 */
export const postOrdersOrderIdSendDelaySms = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DelaySmsSent> => {
  return customFetch<DelaySmsSent>(getPostOrdersOrderIdSendDelaySmsUrl(orderId), {
    ...options,
    method: 'POST',
  })
}

export const getPostOrdersOrderIdSendDelaySmsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdSendDelaySms>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdSendDelaySms>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdSendDelaySms']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdSendDelaySms>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return postOrdersOrderIdSendDelaySms(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdSendDelaySmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdSendDelaySms>>
>

export type PostOrdersOrderIdSendDelaySmsMutationError = unknown

/**
 * @summary Send the running-late text for one order, by hand
 */
export const usePostOrdersOrderIdSendDelaySms = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdSendDelaySms>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdSendDelaySms>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdSendDelaySmsMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdReturnToKitchenUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/return-to-kitchen`
}

/**
 * @summary Re-open a finished order and send it back to the kitchen
 */
export const postOrdersOrderIdReturnToKitchen = async (
  orderId: number,
  returnOrderToKitchenRequest: ReturnOrderToKitchenRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderReturnedToKitchen> => {
  return customFetch<OrderReturnedToKitchen>(getPostOrdersOrderIdReturnToKitchenUrl(orderId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnOrderToKitchenRequest),
  })
}

export const getPostOrdersOrderIdReturnToKitchenMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdReturnToKitchen>>,
    TError,
    { orderId: number; data: ReturnOrderToKitchenRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdReturnToKitchen>>,
  TError,
  { orderId: number; data: ReturnOrderToKitchenRequest },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdReturnToKitchen']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdReturnToKitchen>>,
    { orderId: number; data: ReturnOrderToKitchenRequest }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return postOrdersOrderIdReturnToKitchen(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdReturnToKitchenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdReturnToKitchen>>
>
export type PostOrdersOrderIdReturnToKitchenMutationBody = ReturnOrderToKitchenRequest
export type PostOrdersOrderIdReturnToKitchenMutationError = unknown

/**
 * @summary Re-open a finished order and send it back to the kitchen
 */
export const usePostOrdersOrderIdReturnToKitchen = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdReturnToKitchen>>,
      TError,
      { orderId: number; data: ReturnOrderToKitchenRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdReturnToKitchen>>,
  TError,
  { orderId: number; data: ReturnOrderToKitchenRequest },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdReturnToKitchenMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdOfferUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/offer`
}

/**
 * @summary Offer an order to the external couriers
 */
export const postOrdersOrderIdOffer = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierOffer> => {
  return customFetch<CourierOffer>(getPostOrdersOrderIdOfferUrl(orderId), {
    ...options,
    method: 'POST',
  })
}

export const getPostOrdersOrderIdOfferMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdOffer>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdOffer>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdOffer']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdOffer>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return postOrdersOrderIdOffer(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdOffer>>
>

export type PostOrdersOrderIdOfferMutationError = unknown

/**
 * @summary Offer an order to the external couriers
 */
export const usePostOrdersOrderIdOffer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdOffer>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdOffer>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdOfferMutationOptions(options), queryClient)
}
export const getDeleteOrdersOrderIdOfferUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/offer`
}

/**
 * @summary Take back an offer nobody has claimed
 */
export const deleteOrdersOrderIdOffer = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteOrdersOrderIdOfferUrl(orderId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteOrdersOrderIdOfferMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrdersOrderIdOffer>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrdersOrderIdOffer>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['deleteOrdersOrderIdOffer']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrdersOrderIdOffer>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return deleteOrdersOrderIdOffer(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteOrdersOrderIdOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrdersOrderIdOffer>>
>

export type DeleteOrdersOrderIdOfferMutationError = unknown

/**
 * @summary Take back an offer nobody has claimed
 */
export const useDeleteOrdersOrderIdOffer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrdersOrderIdOffer>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrdersOrderIdOffer>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getDeleteOrdersOrderIdOfferMutationOptions(options), queryClient)
}
export const getGetOrdersOrderIdLoyaltyPointsUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/loyalty-points`
}

/**
 * @summary The loyalty points on a bill, if any
 */
export const getOrdersOrderIdLoyaltyPoints = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<TablePointsState> => {
  return customFetch<TablePointsState>(getGetOrdersOrderIdLoyaltyPointsUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersOrderIdLoyaltyPointsQueryKey = (orderId: number) => {
  return [`/api/v1/orders/${orderId}/loyalty-points`] as const
}

export const getGetOrdersOrderIdLoyaltyPointsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersOrderIdLoyaltyPointsQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>> = ({
    signal,
  }) => getOrdersOrderIdLoyaltyPoints(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetOrdersOrderIdLoyaltyPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>
>
export type GetOrdersOrderIdLoyaltyPointsQueryError = unknown

export function useGetOrdersOrderIdLoyaltyPoints<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdLoyaltyPoints<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdLoyaltyPoints<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The loyalty points on a bill, if any
 */

export function useGetOrdersOrderIdLoyaltyPoints<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdLoyaltyPoints>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersOrderIdLoyaltyPointsQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostOrdersOrderIdLoyaltyPointsUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/loyalty-points`
}

/**
 * @summary Spend a customer's loyalty points on a bill
 */
export const postOrdersOrderIdLoyaltyPoints = async (
  orderId: number,
  tablePointsSpendRequest: TablePointsSpendRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<TablePointsApplied> => {
  return customFetch<TablePointsApplied>(getPostOrdersOrderIdLoyaltyPointsUrl(orderId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tablePointsSpendRequest),
  })
}

export const getPostOrdersOrderIdLoyaltyPointsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPoints>>,
    TError,
    { orderId: number; data: TablePointsSpendRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPoints>>,
  TError,
  { orderId: number; data: TablePointsSpendRequest },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdLoyaltyPoints']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPoints>>,
    { orderId: number; data: TablePointsSpendRequest }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return postOrdersOrderIdLoyaltyPoints(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdLoyaltyPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPoints>>
>
export type PostOrdersOrderIdLoyaltyPointsMutationBody = TablePointsSpendRequest
export type PostOrdersOrderIdLoyaltyPointsMutationError = unknown

/**
 * @summary Spend a customer's loyalty points on a bill
 */
export const usePostOrdersOrderIdLoyaltyPoints = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPoints>>,
      TError,
      { orderId: number; data: TablePointsSpendRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPoints>>,
  TError,
  { orderId: number; data: TablePointsSpendRequest },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdLoyaltyPointsMutationOptions(options), queryClient)
}
export const getDeleteOrdersOrderIdLoyaltyPointsUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/loyalty-points`
}

/**
 * @summary Take the loyalty points off a bill and give them back
 */
export const deleteOrdersOrderIdLoyaltyPoints = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<TablePointsOnTheBill> => {
  return customFetch<TablePointsOnTheBill>(getDeleteOrdersOrderIdLoyaltyPointsUrl(orderId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteOrdersOrderIdLoyaltyPointsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrdersOrderIdLoyaltyPoints>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrdersOrderIdLoyaltyPoints>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['deleteOrdersOrderIdLoyaltyPoints']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrdersOrderIdLoyaltyPoints>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return deleteOrdersOrderIdLoyaltyPoints(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteOrdersOrderIdLoyaltyPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrdersOrderIdLoyaltyPoints>>
>

export type DeleteOrdersOrderIdLoyaltyPointsMutationError = unknown

/**
 * @summary Take the loyalty points off a bill and give them back
 */
export const useDeleteOrdersOrderIdLoyaltyPoints = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrdersOrderIdLoyaltyPoints>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrdersOrderIdLoyaltyPoints>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getDeleteOrdersOrderIdLoyaltyPointsMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdLoyaltyPointsQuoteUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/loyalty-points/quote`
}

/**
 * @summary Whose points a customer's code spends, and how many this bill can take
 */
export const postOrdersOrderIdLoyaltyPointsQuote = async (
  orderId: number,
  tablePointsCodeRequest: TablePointsCodeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<TablePointsQuote> => {
  return customFetch<TablePointsQuote>(getPostOrdersOrderIdLoyaltyPointsQuoteUrl(orderId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tablePointsCodeRequest),
  })
}

export const getPostOrdersOrderIdLoyaltyPointsQuoteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPointsQuote>>,
    TError,
    { orderId: number; data: TablePointsCodeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPointsQuote>>,
  TError,
  { orderId: number; data: TablePointsCodeRequest },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdLoyaltyPointsQuote']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPointsQuote>>,
    { orderId: number; data: TablePointsCodeRequest }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return postOrdersOrderIdLoyaltyPointsQuote(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdLoyaltyPointsQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPointsQuote>>
>
export type PostOrdersOrderIdLoyaltyPointsQuoteMutationBody = TablePointsCodeRequest
export type PostOrdersOrderIdLoyaltyPointsQuoteMutationError = unknown

/**
 * @summary Whose points a customer's code spends, and how many this bill can take
 */
export const usePostOrdersOrderIdLoyaltyPointsQuote = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPointsQuote>>,
      TError,
      { orderId: number; data: TablePointsCodeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdLoyaltyPointsQuote>>,
  TError,
  { orderId: number; data: TablePointsCodeRequest },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdLoyaltyPointsQuoteMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdConfirmStatusUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/confirm-status`
}

/**
 * @summary Close, cancel or hand back an order, with a reason and a named confirmer
 */
export const postOrdersOrderIdConfirmStatus = async (
  orderId: number,
  confirmOrderStatusRequest: ConfirmOrderStatusRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderStatusConfirmed> => {
  return customFetch<OrderStatusConfirmed>(getPostOrdersOrderIdConfirmStatusUrl(orderId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmOrderStatusRequest),
  })
}

export const getPostOrdersOrderIdConfirmStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdConfirmStatus>>,
    TError,
    { orderId: number; data: ConfirmOrderStatusRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdConfirmStatus>>,
  TError,
  { orderId: number; data: ConfirmOrderStatusRequest },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdConfirmStatus']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdConfirmStatus>>,
    { orderId: number; data: ConfirmOrderStatusRequest }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return postOrdersOrderIdConfirmStatus(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdConfirmStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdConfirmStatus>>
>
export type PostOrdersOrderIdConfirmStatusMutationBody = ConfirmOrderStatusRequest
export type PostOrdersOrderIdConfirmStatusMutationError = unknown

/**
 * @summary Close, cancel or hand back an order, with a reason and a named confirmer
 */
export const usePostOrdersOrderIdConfirmStatus = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdConfirmStatus>>,
      TError,
      { orderId: number; data: ConfirmOrderStatusRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdConfirmStatus>>,
  TError,
  { orderId: number; data: ConfirmOrderStatusRequest },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdConfirmStatusMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdCloseWithoutDocumentUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/close-without-document`
}

/**
 * @summary Close a table with no fiscal document, recording who closed it and why
 */
export const postOrdersOrderIdCloseWithoutDocument = async (
  orderId: number,
  closeOrderWithoutDocumentRequest: CloseOrderWithoutDocumentRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderClosedWithoutDocument> => {
  return customFetch<OrderClosedWithoutDocument>(
    getPostOrdersOrderIdCloseWithoutDocumentUrl(orderId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(closeOrderWithoutDocumentRequest),
    },
  )
}

export const getPostOrdersOrderIdCloseWithoutDocumentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdCloseWithoutDocument>>,
    TError,
    { orderId: number; data: CloseOrderWithoutDocumentRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdCloseWithoutDocument>>,
  TError,
  { orderId: number; data: CloseOrderWithoutDocumentRequest },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdCloseWithoutDocument']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdCloseWithoutDocument>>,
    { orderId: number; data: CloseOrderWithoutDocumentRequest }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return postOrdersOrderIdCloseWithoutDocument(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdCloseWithoutDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdCloseWithoutDocument>>
>
export type PostOrdersOrderIdCloseWithoutDocumentMutationBody = CloseOrderWithoutDocumentRequest
export type PostOrdersOrderIdCloseWithoutDocumentMutationError = unknown

/**
 * @summary Close a table with no fiscal document, recording who closed it and why
 */
export const usePostOrdersOrderIdCloseWithoutDocument = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdCloseWithoutDocument>>,
      TError,
      { orderId: number; data: CloseOrderWithoutDocumentRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdCloseWithoutDocument>>,
  TError,
  { orderId: number; data: CloseOrderWithoutDocumentRequest },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdCloseWithoutDocumentMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdBlockUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/block`
}

/**
 * @summary Block an order's phone, e-mail and/or IP address
 */
export const postOrdersOrderIdBlock = async (
  orderId: number,
  blockOrderContactsRequest: BlockOrderContactsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<BlockedContact[]> => {
  return customFetch<BlockedContact[]>(getPostOrdersOrderIdBlockUrl(orderId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blockOrderContactsRequest),
  })
}

export const getPostOrdersOrderIdBlockMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdBlock>>,
    TError,
    { orderId: number; data: BlockOrderContactsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdBlock>>,
  TError,
  { orderId: number; data: BlockOrderContactsRequest },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdBlock']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdBlock>>,
    { orderId: number; data: BlockOrderContactsRequest }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return postOrdersOrderIdBlock(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdBlock>>
>
export type PostOrdersOrderIdBlockMutationBody = BlockOrderContactsRequest
export type PostOrdersOrderIdBlockMutationError = unknown

/**
 * @summary Block an order's phone, e-mail and/or IP address
 */
export const usePostOrdersOrderIdBlock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdBlock>>,
      TError,
      { orderId: number; data: BlockOrderContactsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdBlock>>,
  TError,
  { orderId: number; data: BlockOrderContactsRequest },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdBlockMutationOptions(options), queryClient)
}
export const getPostOrdersSplitPaymentUrl = () => {
  return `/api/v1/orders/split-payment`
}

/**
 * @summary Pay part of a table's bill and leave the rest open
 */
export const postOrdersSplitPayment = async (
  splitPaymentRequest: SplitPaymentRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SplitPaymentResult> => {
  return customFetch<SplitPaymentResult>(getPostOrdersSplitPaymentUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(splitPaymentRequest),
  })
}

export const getPostOrdersSplitPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersSplitPayment>>,
    TError,
    { data: SplitPaymentRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersSplitPayment>>,
  TError,
  { data: SplitPaymentRequest },
  TContext
> => {
  const mutationKey = ['postOrdersSplitPayment']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersSplitPayment>>,
    { data: SplitPaymentRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postOrdersSplitPayment(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersSplitPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersSplitPayment>>
>
export type PostOrdersSplitPaymentMutationBody = SplitPaymentRequest
export type PostOrdersSplitPaymentMutationError = unknown

/**
 * @summary Pay part of a table's bill and leave the rest open
 */
export const usePostOrdersSplitPayment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersSplitPayment>>,
      TError,
      { data: SplitPaymentRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersSplitPayment>>,
  TError,
  { data: SplitPaymentRequest },
  TContext
> => {
  return useMutation(getPostOrdersSplitPaymentMutationOptions(options), queryClient)
}
export const getPostOrdersBulkDispatchUrl = () => {
  return `/api/v1/orders/bulk-dispatch`
}

/**
 * @summary Send several orders out as one delivery run
 */
export const postOrdersBulkDispatch = async (
  bulkDispatchRequest: BulkDispatchRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrdersDispatched> => {
  return customFetch<OrdersDispatched>(getPostOrdersBulkDispatchUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkDispatchRequest),
  })
}

export const getPostOrdersBulkDispatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersBulkDispatch>>,
    TError,
    { data: BulkDispatchRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersBulkDispatch>>,
  TError,
  { data: BulkDispatchRequest },
  TContext
> => {
  const mutationKey = ['postOrdersBulkDispatch']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersBulkDispatch>>,
    { data: BulkDispatchRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postOrdersBulkDispatch(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersBulkDispatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersBulkDispatch>>
>
export type PostOrdersBulkDispatchMutationBody = BulkDispatchRequest
export type PostOrdersBulkDispatchMutationError = unknown

/**
 * @summary Send several orders out as one delivery run
 */
export const usePostOrdersBulkDispatch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersBulkDispatch>>,
      TError,
      { data: BulkDispatchRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersBulkDispatch>>,
  TError,
  { data: BulkDispatchRequest },
  TContext
> => {
  return useMutation(getPostOrdersBulkDispatchMutationOptions(options), queryClient)
}
export const getGetOrderTabsUrl = () => {
  return `/api/v1/order-tabs`
}

/**
 * @summary Tabs that are still owed
 */
export const getOrderTabs = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTab[]> => {
  return customFetch<OrderTab[]>(getGetOrderTabsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrderTabsQueryKey = () => {
  return [`/api/v1/order-tabs`] as const
}

export const getGetOrderTabsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderTabs>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabs>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrderTabsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderTabs>>> = ({ signal }) =>
    getOrderTabs({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderTabs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderTabsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderTabs>>>
export type GetOrderTabsQueryError = unknown

export function useGetOrderTabs<TData = Awaited<ReturnType<typeof getOrderTabs>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderTabs>>,
          TError,
          Awaited<ReturnType<typeof getOrderTabs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderTabs<TData = Awaited<ReturnType<typeof getOrderTabs>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderTabs>>,
          TError,
          Awaited<ReturnType<typeof getOrderTabs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderTabs<TData = Awaited<ReturnType<typeof getOrderTabs>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Tabs that are still owed
 */

export function useGetOrderTabs<TData = Awaited<ReturnType<typeof getOrderTabs>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrderTabsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostOrderTabsUrl = () => {
  return `/api/v1/order-tabs`
}

/**
 * @summary Open a tab
 */
export const postOrderTabs = async (
  postOrderTabsBody: PostOrderTabsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTabDetail> => {
  return customFetch<OrderTabDetail>(getPostOrderTabsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postOrderTabsBody),
  })
}

export const getPostOrderTabsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrderTabs>>,
    TError,
    { data: PostOrderTabsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrderTabs>>,
  TError,
  { data: PostOrderTabsBody },
  TContext
> => {
  const mutationKey = ['postOrderTabs']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrderTabs>>,
    { data: PostOrderTabsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postOrderTabs(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrderTabsMutationResult = NonNullable<Awaited<ReturnType<typeof postOrderTabs>>>
export type PostOrderTabsMutationBody = PostOrderTabsBody
export type PostOrderTabsMutationError = unknown

/**
 * @summary Open a tab
 */
export const usePostOrderTabs = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrderTabs>>,
      TError,
      { data: PostOrderTabsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrderTabs>>,
  TError,
  { data: PostOrderTabsBody },
  TContext
> => {
  return useMutation(getPostOrderTabsMutationOptions(options), queryClient)
}
export const getPostOrderTabsIdSettleUrl = (id: number) => {
  return `/api/v1/order-tabs/${id}/settle`
}

/**
 * @summary Take a payment against a tab, in full or in part
 */
export const postOrderTabsIdSettle = async (
  id: number,
  postOrderTabsIdSettleBody: PostOrderTabsIdSettleBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTabDetail> => {
  return customFetch<OrderTabDetail>(getPostOrderTabsIdSettleUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postOrderTabsIdSettleBody),
  })
}

export const getPostOrderTabsIdSettleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrderTabsIdSettle>>,
    TError,
    { id: number; data: PostOrderTabsIdSettleBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrderTabsIdSettle>>,
  TError,
  { id: number; data: PostOrderTabsIdSettleBody },
  TContext
> => {
  const mutationKey = ['postOrderTabsIdSettle']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrderTabsIdSettle>>,
    { id: number; data: PostOrderTabsIdSettleBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return postOrderTabsIdSettle(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrderTabsIdSettleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrderTabsIdSettle>>
>
export type PostOrderTabsIdSettleMutationBody = PostOrderTabsIdSettleBody
export type PostOrderTabsIdSettleMutationError = unknown

/**
 * @summary Take a payment against a tab, in full or in part
 */
export const usePostOrderTabsIdSettle = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrderTabsIdSettle>>,
      TError,
      { id: number; data: PostOrderTabsIdSettleBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrderTabsIdSettle>>,
  TError,
  { id: number; data: PostOrderTabsIdSettleBody },
  TContext
> => {
  return useMutation(getPostOrderTabsIdSettleMutationOptions(options), queryClient)
}
export const getPostOrderTabsIdOrdersOrderIdUrl = (id: number, orderId: number) => {
  return `/api/v1/order-tabs/${id}/orders/${orderId}`
}

/**
 * @summary Put an order on a tab
 */
export const postOrderTabsIdOrdersOrderId = async (
  id: number,
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTabDetail> => {
  return customFetch<OrderTabDetail>(getPostOrderTabsIdOrdersOrderIdUrl(id, orderId), {
    ...options,
    method: 'POST',
  })
}

export const getPostOrderTabsIdOrdersOrderIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrderTabsIdOrdersOrderId>>,
    TError,
    { id: number; orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrderTabsIdOrdersOrderId>>,
  TError,
  { id: number; orderId: number },
  TContext
> => {
  const mutationKey = ['postOrderTabsIdOrdersOrderId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrderTabsIdOrdersOrderId>>,
    { id: number; orderId: number }
  > = (props) => {
    const { id, orderId } = props ?? {}

    return postOrderTabsIdOrdersOrderId(id, orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrderTabsIdOrdersOrderIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrderTabsIdOrdersOrderId>>
>

export type PostOrderTabsIdOrdersOrderIdMutationError = unknown

/**
 * @summary Put an order on a tab
 */
export const usePostOrderTabsIdOrdersOrderId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrderTabsIdOrdersOrderId>>,
      TError,
      { id: number; orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrderTabsIdOrdersOrderId>>,
  TError,
  { id: number; orderId: number },
  TContext
> => {
  return useMutation(getPostOrderTabsIdOrdersOrderIdMutationOptions(options), queryClient)
}
export const getDeleteOrderTabsIdOrdersOrderIdUrl = (id: number, orderId: number) => {
  return `/api/v1/order-tabs/${id}/orders/${orderId}`
}

/**
 * @summary Take an order back off a tab
 */
export const deleteOrderTabsIdOrdersOrderId = async (
  id: number,
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTabDetail> => {
  return customFetch<OrderTabDetail>(getDeleteOrderTabsIdOrdersOrderIdUrl(id, orderId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteOrderTabsIdOrdersOrderIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrderTabsIdOrdersOrderId>>,
    TError,
    { id: number; orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrderTabsIdOrdersOrderId>>,
  TError,
  { id: number; orderId: number },
  TContext
> => {
  const mutationKey = ['deleteOrderTabsIdOrdersOrderId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrderTabsIdOrdersOrderId>>,
    { id: number; orderId: number }
  > = (props) => {
    const { id, orderId } = props ?? {}

    return deleteOrderTabsIdOrdersOrderId(id, orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteOrderTabsIdOrdersOrderIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrderTabsIdOrdersOrderId>>
>

export type DeleteOrderTabsIdOrdersOrderIdMutationError = unknown

/**
 * @summary Take an order back off a tab
 */
export const useDeleteOrderTabsIdOrdersOrderId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrderTabsIdOrdersOrderId>>,
      TError,
      { id: number; orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrderTabsIdOrdersOrderId>>,
  TError,
  { id: number; orderId: number },
  TContext
> => {
  return useMutation(getDeleteOrderTabsIdOrdersOrderIdMutationOptions(options), queryClient)
}
export const getGetKitchenCallsUrl = (params?: GetKitchenCallsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/kitchen/calls?${stringifiedParams}`
    : `/api/v1/kitchen/calls`
}

/**
 * @summary The kitchen's calls after the screen's mark, from the last two minutes
 */
export const getKitchenCalls = async (
  params?: GetKitchenCallsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<KitchenCalls> => {
  return customFetch<KitchenCalls>(getGetKitchenCallsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetKitchenCallsQueryKey = (params?: GetKitchenCallsParams) => {
  return [`/api/v1/kitchen/calls`, ...(params ? [params] : [])] as const
}

export const getGetKitchenCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getKitchenCalls>>,
  TError = unknown,
>(
  params?: GetKitchenCallsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenCalls>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetKitchenCallsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKitchenCalls>>> = ({ signal }) =>
    getKitchenCalls(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKitchenCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetKitchenCallsQueryResult = NonNullable<Awaited<ReturnType<typeof getKitchenCalls>>>
export type GetKitchenCallsQueryError = unknown

export function useGetKitchenCalls<
  TData = Awaited<ReturnType<typeof getKitchenCalls>>,
  TError = unknown,
>(
  params: undefined | GetKitchenCallsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenCalls>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKitchenCalls>>,
          TError,
          Awaited<ReturnType<typeof getKitchenCalls>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKitchenCalls<
  TData = Awaited<ReturnType<typeof getKitchenCalls>>,
  TError = unknown,
>(
  params?: GetKitchenCallsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenCalls>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKitchenCalls>>,
          TError,
          Awaited<ReturnType<typeof getKitchenCalls>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKitchenCalls<
  TData = Awaited<ReturnType<typeof getKitchenCalls>>,
  TError = unknown,
>(
  params?: GetKitchenCallsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenCalls>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The kitchen's calls after the screen's mark, from the last two minutes
 */

export function useGetKitchenCalls<
  TData = Awaited<ReturnType<typeof getKitchenCalls>>,
  TError = unknown,
>(
  params?: GetKitchenCallsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKitchenCalls>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetKitchenCallsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostKitchenCallsUrl = () => {
  return `/api/v1/kitchen/calls`
}

/**
 * @summary Call the waiters from the kitchen, about an order or in general
 */
export const postKitchenCalls = async (
  kitchenCallRequest?: KitchenCallRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<KitchenCall> => {
  return customFetch<KitchenCall>(getPostKitchenCallsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(kitchenCallRequest),
  })
}

export const getPostKitchenCallsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postKitchenCalls>>,
    TError,
    { data?: KitchenCallRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postKitchenCalls>>,
  TError,
  { data?: KitchenCallRequest },
  TContext
> => {
  const mutationKey = ['postKitchenCalls']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postKitchenCalls>>,
    { data?: KitchenCallRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postKitchenCalls(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostKitchenCallsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postKitchenCalls>>
>
export type PostKitchenCallsMutationBody = KitchenCallRequest | undefined
export type PostKitchenCallsMutationError = unknown

/**
 * @summary Call the waiters from the kitchen, about an order or in general
 */
export const usePostKitchenCalls = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postKitchenCalls>>,
      TError,
      { data?: KitchenCallRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postKitchenCalls>>,
  TError,
  { data?: KitchenCallRequest },
  TContext
> => {
  return useMutation(getPostKitchenCallsMutationOptions(options), queryClient)
}
export const getPostEmployeesIdCourierSettlementsUrl = (id: number) => {
  return `/api/v1/employees/${id}/courier-settlements`
}

/**
 * @summary Record a payment between a courier and the restaurant
 */
export const postEmployeesIdCourierSettlements = async (
  id: number,
  courierSettlementRequest: CourierSettlementRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierBalance> => {
  return customFetch<CourierBalance>(getPostEmployeesIdCourierSettlementsUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(courierSettlementRequest),
  })
}

export const getPostEmployeesIdCourierSettlementsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmployeesIdCourierSettlements>>,
    TError,
    { id: number; data: CourierSettlementRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmployeesIdCourierSettlements>>,
  TError,
  { id: number; data: CourierSettlementRequest },
  TContext
> => {
  const mutationKey = ['postEmployeesIdCourierSettlements']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmployeesIdCourierSettlements>>,
    { id: number; data: CourierSettlementRequest }
  > = (props) => {
    const { id, data } = props ?? {}

    return postEmployeesIdCourierSettlements(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostEmployeesIdCourierSettlementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmployeesIdCourierSettlements>>
>
export type PostEmployeesIdCourierSettlementsMutationBody = CourierSettlementRequest
export type PostEmployeesIdCourierSettlementsMutationError = unknown

/**
 * @summary Record a payment between a courier and the restaurant
 */
export const usePostEmployeesIdCourierSettlements = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postEmployeesIdCourierSettlements>>,
      TError,
      { id: number; data: CourierSettlementRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postEmployeesIdCourierSettlements>>,
  TError,
  { id: number; data: CourierSettlementRequest },
  TContext
> => {
  return useMutation(getPostEmployeesIdCourierSettlementsMutationOptions(options), queryClient)
}
export const getPostDriverPoolOrderIdReleaseUrl = (orderId: number) => {
  return `/api/v1/driver-pool/${orderId}/release`
}

/**
 * @summary Give an order back to the pool before it leaves the restaurant
 */
export const postDriverPoolOrderIdRelease = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostDriverPoolOrderIdReleaseUrl(orderId), {
    ...options,
    method: 'POST',
  })
}

export const getPostDriverPoolOrderIdReleaseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDriverPoolOrderIdRelease>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDriverPoolOrderIdRelease>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['postDriverPoolOrderIdRelease']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDriverPoolOrderIdRelease>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return postDriverPoolOrderIdRelease(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostDriverPoolOrderIdReleaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDriverPoolOrderIdRelease>>
>

export type PostDriverPoolOrderIdReleaseMutationError = unknown

/**
 * @summary Give an order back to the pool before it leaves the restaurant
 */
export const usePostDriverPoolOrderIdRelease = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDriverPoolOrderIdRelease>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDriverPoolOrderIdRelease>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getPostDriverPoolOrderIdReleaseMutationOptions(options), queryClient)
}
export const getPostDriverPoolOrderIdClaimUrl = (orderId: number) => {
  return `/api/v1/driver-pool/${orderId}/claim`
}

/**
 * @summary Take an order from the pool
 */
export const postDriverPoolOrderIdClaim = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierOrder> => {
  return customFetch<CourierOrder>(getPostDriverPoolOrderIdClaimUrl(orderId), {
    ...options,
    method: 'POST',
  })
}

export const getPostDriverPoolOrderIdClaimMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDriverPoolOrderIdClaim>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDriverPoolOrderIdClaim>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['postDriverPoolOrderIdClaim']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDriverPoolOrderIdClaim>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return postDriverPoolOrderIdClaim(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostDriverPoolOrderIdClaimMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDriverPoolOrderIdClaim>>
>

export type PostDriverPoolOrderIdClaimMutationError = unknown

/**
 * @summary Take an order from the pool
 */
export const usePostDriverPoolOrderIdClaim = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDriverPoolOrderIdClaim>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDriverPoolOrderIdClaim>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getPostDriverPoolOrderIdClaimMutationOptions(options), queryClient)
}
export const getGetCustomersCustomerIdBlockUrl = (customerId: number) => {
  return `/api/v1/customers/${customerId}/block`
}

/**
 * @summary Whether a customer's e-mail or phone is blocked
 */
export const getCustomersCustomerIdBlock = async (
  customerId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBlock> => {
  return customFetch<CustomerBlock>(getGetCustomersCustomerIdBlockUrl(customerId), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomersCustomerIdBlockQueryKey = (customerId: number) => {
  return [`/api/v1/customers/${customerId}/block`] as const
}

export const getGetCustomersCustomerIdBlockQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomersCustomerIdBlockQueryKey(customerId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>> = ({
    signal,
  }) => getCustomersCustomerIdBlock(customerId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: customerId !== null && customerId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCustomersCustomerIdBlockQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>
>
export type GetCustomersCustomerIdBlockQueryError = unknown

export function useGetCustomersCustomerIdBlock<
  TData = Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>,
  TError = unknown,
>(
  customerId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>,
          TError,
          Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersCustomerIdBlock<
  TData = Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>,
          TError,
          Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersCustomerIdBlock<
  TData = Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether a customer's e-mail or phone is blocked
 */

export function useGetCustomersCustomerIdBlock<
  TData = Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerIdBlock>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomersCustomerIdBlockQueryOptions(customerId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostCustomersCustomerIdBlockUrl = (customerId: number) => {
  return `/api/v1/customers/${customerId}/block`
}

/**
 * @summary Block a customer's e-mail and phone
 */
export const postCustomersCustomerIdBlock = async (
  customerId: number,
  blockCustomerRequest?: BlockCustomerRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBlock> => {
  return customFetch<CustomerBlock>(getPostCustomersCustomerIdBlockUrl(customerId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blockCustomerRequest),
  })
}

export const getPostCustomersCustomerIdBlockMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersCustomerIdBlock>>,
    TError,
    { customerId: number; data?: BlockCustomerRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersCustomerIdBlock>>,
  TError,
  { customerId: number; data?: BlockCustomerRequest },
  TContext
> => {
  const mutationKey = ['postCustomersCustomerIdBlock']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersCustomerIdBlock>>,
    { customerId: number; data?: BlockCustomerRequest }
  > = (props) => {
    const { customerId, data } = props ?? {}

    return postCustomersCustomerIdBlock(customerId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersCustomerIdBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersCustomerIdBlock>>
>
export type PostCustomersCustomerIdBlockMutationBody = BlockCustomerRequest | undefined
export type PostCustomersCustomerIdBlockMutationError = unknown

/**
 * @summary Block a customer's e-mail and phone
 */
export const usePostCustomersCustomerIdBlock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersCustomerIdBlock>>,
      TError,
      { customerId: number; data?: BlockCustomerRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersCustomerIdBlock>>,
  TError,
  { customerId: number; data?: BlockCustomerRequest },
  TContext
> => {
  return useMutation(getPostCustomersCustomerIdBlockMutationOptions(options), queryClient)
}
export const getDeleteCustomersCustomerIdBlockUrl = (customerId: number) => {
  return `/api/v1/customers/${customerId}/block`
}

/**
 * @summary Take a customer's blocks off
 */
export const deleteCustomersCustomerIdBlock = async (
  customerId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBlock> => {
  return customFetch<CustomerBlock>(getDeleteCustomersCustomerIdBlockUrl(customerId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteCustomersCustomerIdBlockMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomersCustomerIdBlock>>,
    TError,
    { customerId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomersCustomerIdBlock>>,
  TError,
  { customerId: number },
  TContext
> => {
  const mutationKey = ['deleteCustomersCustomerIdBlock']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomersCustomerIdBlock>>,
    { customerId: number }
  > = (props) => {
    const { customerId } = props ?? {}

    return deleteCustomersCustomerIdBlock(customerId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCustomersCustomerIdBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomersCustomerIdBlock>>
>

export type DeleteCustomersCustomerIdBlockMutationError = unknown

/**
 * @summary Take a customer's blocks off
 */
export const useDeleteCustomersCustomerIdBlock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomersCustomerIdBlock>>,
      TError,
      { customerId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomersCustomerIdBlock>>,
  TError,
  { customerId: number },
  TContext
> => {
  return useMutation(getDeleteCustomersCustomerIdBlockMutationOptions(options), queryClient)
}
export const getGetBlockedContactsUrl = () => {
  return `/api/v1/blocked-contacts`
}

/**
 * @summary Every blocked e-mail, phone number and IP address
 */
export const getBlockedContacts = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BlockedContact[]> => {
  return customFetch<BlockedContact[]>(getGetBlockedContactsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetBlockedContactsQueryKey = () => {
  return [`/api/v1/blocked-contacts`] as const
}

export const getGetBlockedContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBlockedContacts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedContacts>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBlockedContactsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlockedContacts>>> = ({ signal }) =>
    getBlockedContacts({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBlockedContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBlockedContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBlockedContacts>>
>
export type GetBlockedContactsQueryError = unknown

export function useGetBlockedContacts<
  TData = Awaited<ReturnType<typeof getBlockedContacts>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedContacts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockedContacts>>,
          TError,
          Awaited<ReturnType<typeof getBlockedContacts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlockedContacts<
  TData = Awaited<ReturnType<typeof getBlockedContacts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlockedContacts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockedContacts>>,
          TError,
          Awaited<ReturnType<typeof getBlockedContacts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlockedContacts<
  TData = Awaited<ReturnType<typeof getBlockedContacts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedContacts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every blocked e-mail, phone number and IP address
 */

export function useGetBlockedContacts<
  TData = Awaited<ReturnType<typeof getBlockedContacts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedContacts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBlockedContactsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostBlockedContactsUrl = () => {
  return `/api/v1/blocked-contacts`
}

/**
 * @summary Block an e-mail, a phone number or an IP address
 */
export const postBlockedContacts = async (
  blockContactRequest: BlockContactRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<BlockedContact> => {
  return customFetch<BlockedContact>(getPostBlockedContactsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(blockContactRequest),
  })
}

export const getPostBlockedContactsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBlockedContacts>>,
    TError,
    { data: BlockContactRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBlockedContacts>>,
  TError,
  { data: BlockContactRequest },
  TContext
> => {
  const mutationKey = ['postBlockedContacts']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBlockedContacts>>,
    { data: BlockContactRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postBlockedContacts(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostBlockedContactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBlockedContacts>>
>
export type PostBlockedContactsMutationBody = BlockContactRequest
export type PostBlockedContactsMutationError = unknown

/**
 * @summary Block an e-mail, a phone number or an IP address
 */
export const usePostBlockedContacts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postBlockedContacts>>,
      TError,
      { data: BlockContactRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postBlockedContacts>>,
  TError,
  { data: BlockContactRequest },
  TContext
> => {
  return useMutation(getPostBlockedContactsMutationOptions(options), queryClient)
}
export const getDeleteVehiclesVehicleIdUrl = (vehicleId: number) => {
  return `/api/v1/vehicles/${vehicleId}`
}

/**
 * @summary Delete a vehicle
 */
export const deleteVehiclesVehicleId = async (
  vehicleId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<VehicleDeleted> => {
  return customFetch<VehicleDeleted>(getDeleteVehiclesVehicleIdUrl(vehicleId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteVehiclesVehicleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVehiclesVehicleId>>,
    TError,
    { vehicleId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVehiclesVehicleId>>,
  TError,
  { vehicleId: number },
  TContext
> => {
  const mutationKey = ['deleteVehiclesVehicleId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVehiclesVehicleId>>,
    { vehicleId: number }
  > = (props) => {
    const { vehicleId } = props ?? {}

    return deleteVehiclesVehicleId(vehicleId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteVehiclesVehicleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVehiclesVehicleId>>
>

export type DeleteVehiclesVehicleIdMutationError = unknown

/**
 * @summary Delete a vehicle
 */
export const useDeleteVehiclesVehicleId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteVehiclesVehicleId>>,
      TError,
      { vehicleId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteVehiclesVehicleId>>,
  TError,
  { vehicleId: number },
  TContext
> => {
  return useMutation(getDeleteVehiclesVehicleIdMutationOptions(options), queryClient)
}
export const getPatchVehiclesVehicleIdUrl = (vehicleId: number) => {
  return `/api/v1/vehicles/${vehicleId}`
}

/**
 * @summary Update a vehicle
 */
export const patchVehiclesVehicleId = async (
  vehicleId: number,
  patchVehiclesVehicleIdBody: PatchVehiclesVehicleIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Vehicle> => {
  return customFetch<Vehicle>(getPatchVehiclesVehicleIdUrl(vehicleId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchVehiclesVehicleIdBody),
  })
}

export const getPatchVehiclesVehicleIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchVehiclesVehicleId>>,
    TError,
    { vehicleId: number; data: PatchVehiclesVehicleIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchVehiclesVehicleId>>,
  TError,
  { vehicleId: number; data: PatchVehiclesVehicleIdBody },
  TContext
> => {
  const mutationKey = ['patchVehiclesVehicleId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchVehiclesVehicleId>>,
    { vehicleId: number; data: PatchVehiclesVehicleIdBody }
  > = (props) => {
    const { vehicleId, data } = props ?? {}

    return patchVehiclesVehicleId(vehicleId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchVehiclesVehicleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchVehiclesVehicleId>>
>
export type PatchVehiclesVehicleIdMutationBody = PatchVehiclesVehicleIdBody
export type PatchVehiclesVehicleIdMutationError = unknown

/**
 * @summary Update a vehicle
 */
export const usePatchVehiclesVehicleId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchVehiclesVehicleId>>,
      TError,
      { vehicleId: number; data: PatchVehiclesVehicleIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchVehiclesVehicleId>>,
  TError,
  { vehicleId: number; data: PatchVehiclesVehicleIdBody },
  TContext
> => {
  return useMutation(getPatchVehiclesVehicleIdMutationOptions(options), queryClient)
}
export const getGetSalesChannelsIdUrl = (id: number) => {
  return `/api/v1/sales-channels/${id}`
}

/**
 * @summary One sales channel
 */
export const getSalesChannelsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SalesChannel> => {
  return customFetch<SalesChannel>(getGetSalesChannelsIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetSalesChannelsIdQueryKey = (id: number) => {
  return [`/api/v1/sales-channels/${id}`] as const
}

export const getGetSalesChannelsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesChannelsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSalesChannelsIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesChannelsId>>> = ({ signal }) =>
    getSalesChannelsId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetSalesChannelsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalesChannelsId>>
>
export type GetSalesChannelsIdQueryError = unknown

export function useGetSalesChannelsId<
  TData = Awaited<ReturnType<typeof getSalesChannelsId>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesChannelsId>>,
          TError,
          Awaited<ReturnType<typeof getSalesChannelsId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesChannelsId<
  TData = Awaited<ReturnType<typeof getSalesChannelsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesChannelsId>>,
          TError,
          Awaited<ReturnType<typeof getSalesChannelsId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesChannelsId<
  TData = Awaited<ReturnType<typeof getSalesChannelsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One sales channel
 */

export function useGetSalesChannelsId<
  TData = Awaited<ReturnType<typeof getSalesChannelsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSalesChannelsIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteSalesChannelsIdUrl = (id: number) => {
  return `/api/v1/sales-channels/${id}`
}

/**
 * @summary Delete a sales channel that has no orders
 */
export const deleteSalesChannelsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SalesChannelDeleted> => {
  return customFetch<SalesChannelDeleted>(getDeleteSalesChannelsIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSalesChannelsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSalesChannelsId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSalesChannelsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSalesChannelsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSalesChannelsId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSalesChannelsId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSalesChannelsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSalesChannelsId>>
>

export type DeleteSalesChannelsIdMutationError = unknown

/**
 * @summary Delete a sales channel that has no orders
 */
export const useDeleteSalesChannelsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSalesChannelsId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSalesChannelsId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSalesChannelsIdMutationOptions(options), queryClient)
}
export const getPatchSalesChannelsIdUrl = (id: number) => {
  return `/api/v1/sales-channels/${id}`
}

/**
 * @summary Change a sales channel
 */
export const patchSalesChannelsId = async (
  id: number,
  patchSalesChannelsIdBody: PatchSalesChannelsIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SalesChannel> => {
  return customFetch<SalesChannel>(getPatchSalesChannelsIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSalesChannelsIdBody),
  })
}

export const getPatchSalesChannelsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSalesChannelsId>>,
    TError,
    { id: number; data: PatchSalesChannelsIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSalesChannelsId>>,
  TError,
  { id: number; data: PatchSalesChannelsIdBody },
  TContext
> => {
  const mutationKey = ['patchSalesChannelsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSalesChannelsId>>,
    { id: number; data: PatchSalesChannelsIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSalesChannelsId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSalesChannelsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSalesChannelsId>>
>
export type PatchSalesChannelsIdMutationBody = PatchSalesChannelsIdBody
export type PatchSalesChannelsIdMutationError = unknown

/**
 * @summary Change a sales channel
 */
export const usePatchSalesChannelsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSalesChannelsId>>,
      TError,
      { id: number; data: PatchSalesChannelsIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSalesChannelsId>>,
  TError,
  { id: number; data: PatchSalesChannelsIdBody },
  TContext
> => {
  return useMutation(getPatchSalesChannelsIdMutationOptions(options), queryClient)
}
export const getDeleteRestaurantZonesZoneIdUrl = (zoneId: number) => {
  return `/api/v1/restaurant-zones/${zoneId}`
}

/**
 * @summary Retire a zone - its tables keep existing
 */
export const deleteRestaurantZonesZoneId = async (
  zoneId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteRestaurantZonesZoneId200> => {
  return customFetch<DeleteRestaurantZonesZoneId200>(getDeleteRestaurantZonesZoneIdUrl(zoneId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteRestaurantZonesZoneIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRestaurantZonesZoneId>>,
    TError,
    { zoneId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRestaurantZonesZoneId>>,
  TError,
  { zoneId: number },
  TContext
> => {
  const mutationKey = ['deleteRestaurantZonesZoneId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRestaurantZonesZoneId>>,
    { zoneId: number }
  > = (props) => {
    const { zoneId } = props ?? {}

    return deleteRestaurantZonesZoneId(zoneId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteRestaurantZonesZoneIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRestaurantZonesZoneId>>
>

export type DeleteRestaurantZonesZoneIdMutationError = unknown

/**
 * @summary Retire a zone - its tables keep existing
 */
export const useDeleteRestaurantZonesZoneId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRestaurantZonesZoneId>>,
      TError,
      { zoneId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRestaurantZonesZoneId>>,
  TError,
  { zoneId: number },
  TContext
> => {
  return useMutation(getDeleteRestaurantZonesZoneIdMutationOptions(options), queryClient)
}
export const getPatchRestaurantZonesZoneIdUrl = (zoneId: number) => {
  return `/api/v1/restaurant-zones/${zoneId}`
}

/**
 * @summary Rename, recolour, or point a zone at a register or a sales channel
 */
export const patchRestaurantZonesZoneId = async (
  zoneId: number,
  updateRestaurantZoneRequest: UpdateRestaurantZoneRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RestaurantZone> => {
  return customFetch<RestaurantZone>(getPatchRestaurantZonesZoneIdUrl(zoneId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateRestaurantZoneRequest),
  })
}

export const getPatchRestaurantZonesZoneIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRestaurantZonesZoneId>>,
    TError,
    { zoneId: number; data: UpdateRestaurantZoneRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchRestaurantZonesZoneId>>,
  TError,
  { zoneId: number; data: UpdateRestaurantZoneRequest },
  TContext
> => {
  const mutationKey = ['patchRestaurantZonesZoneId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchRestaurantZonesZoneId>>,
    { zoneId: number; data: UpdateRestaurantZoneRequest }
  > = (props) => {
    const { zoneId, data } = props ?? {}

    return patchRestaurantZonesZoneId(zoneId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchRestaurantZonesZoneIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchRestaurantZonesZoneId>>
>
export type PatchRestaurantZonesZoneIdMutationBody = UpdateRestaurantZoneRequest
export type PatchRestaurantZonesZoneIdMutationError = unknown

/**
 * @summary Rename, recolour, or point a zone at a register or a sales channel
 */
export const usePatchRestaurantZonesZoneId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchRestaurantZonesZoneId>>,
      TError,
      { zoneId: number; data: UpdateRestaurantZoneRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchRestaurantZonesZoneId>>,
  TError,
  { zoneId: number; data: UpdateRestaurantZoneRequest },
  TContext
> => {
  return useMutation(getPatchRestaurantZonesZoneIdMutationOptions(options), queryClient)
}
export const getDeleteRestaurantTablesTableIdUrl = (
  tableId: number,
  params?: DeleteRestaurantTablesTableIdParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/restaurant-tables/${tableId}?${stringifiedParams}`
    : `/api/v1/restaurant-tables/${tableId}`
}

/**
 * @summary Remove a table from the plan
 */
export const deleteRestaurantTablesTableId = async (
  tableId: number,
  params?: DeleteRestaurantTablesTableIdParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TableDeleted> => {
  return customFetch<TableDeleted>(getDeleteRestaurantTablesTableIdUrl(tableId, params), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteRestaurantTablesTableIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRestaurantTablesTableId>>,
    TError,
    { tableId: number; params?: DeleteRestaurantTablesTableIdParams },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRestaurantTablesTableId>>,
  TError,
  { tableId: number; params?: DeleteRestaurantTablesTableIdParams },
  TContext
> => {
  const mutationKey = ['deleteRestaurantTablesTableId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRestaurantTablesTableId>>,
    { tableId: number; params?: DeleteRestaurantTablesTableIdParams }
  > = (props) => {
    const { tableId, params } = props ?? {}

    return deleteRestaurantTablesTableId(tableId, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteRestaurantTablesTableIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRestaurantTablesTableId>>
>

export type DeleteRestaurantTablesTableIdMutationError = unknown

/**
 * @summary Remove a table from the plan
 */
export const useDeleteRestaurantTablesTableId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRestaurantTablesTableId>>,
      TError,
      { tableId: number; params?: DeleteRestaurantTablesTableIdParams },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRestaurantTablesTableId>>,
  TError,
  { tableId: number; params?: DeleteRestaurantTablesTableIdParams },
  TContext
> => {
  return useMutation(getDeleteRestaurantTablesTableIdMutationOptions(options), queryClient)
}
export const getPatchRestaurantTablesTableIdUrl = (tableId: number) => {
  return `/api/v1/restaurant-tables/${tableId}`
}

/**
 * @summary Move, resize or rename one table
 */
export const patchRestaurantTablesTableId = async (
  tableId: number,
  updateRestaurantTableRequest: UpdateRestaurantTableRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchRestaurantTablesTableId200> => {
  return customFetch<PatchRestaurantTablesTableId200>(getPatchRestaurantTablesTableIdUrl(tableId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateRestaurantTableRequest),
  })
}

export const getPatchRestaurantTablesTableIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRestaurantTablesTableId>>,
    TError,
    { tableId: number; data: UpdateRestaurantTableRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchRestaurantTablesTableId>>,
  TError,
  { tableId: number; data: UpdateRestaurantTableRequest },
  TContext
> => {
  const mutationKey = ['patchRestaurantTablesTableId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchRestaurantTablesTableId>>,
    { tableId: number; data: UpdateRestaurantTableRequest }
  > = (props) => {
    const { tableId, data } = props ?? {}

    return patchRestaurantTablesTableId(tableId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchRestaurantTablesTableIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchRestaurantTablesTableId>>
>
export type PatchRestaurantTablesTableIdMutationBody = UpdateRestaurantTableRequest
export type PatchRestaurantTablesTableIdMutationError = unknown

/**
 * @summary Move, resize or rename one table
 */
export const usePatchRestaurantTablesTableId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchRestaurantTablesTableId>>,
      TError,
      { tableId: number; data: UpdateRestaurantTableRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchRestaurantTablesTableId>>,
  TError,
  { tableId: number; data: UpdateRestaurantTableRequest },
  TContext
> => {
  return useMutation(getPatchRestaurantTablesTableIdMutationOptions(options), queryClient)
}
export const getGetOrdersOrderIdUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}`
}

/**
 * @summary One order
 */
export const getOrdersOrderId = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Order> => {
  return customFetch<Order>(getGetOrdersOrderIdUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersOrderIdQueryKey = (orderId: number) => {
  return [`/api/v1/orders/${orderId}`] as const
}

export const getGetOrdersOrderIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersOrderIdQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersOrderId>>> = ({ signal }) =>
    getOrdersOrderId(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetOrdersOrderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOrdersOrderId>>>
export type GetOrdersOrderIdQueryError = unknown

export function useGetOrdersOrderId<
  TData = Awaited<ReturnType<typeof getOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderId<
  TData = Awaited<ReturnType<typeof getOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderId<
  TData = Awaited<ReturnType<typeof getOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One order
 */

export function useGetOrdersOrderId<
  TData = Awaited<ReturnType<typeof getOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersOrderIdQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteOrdersOrderIdUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}`
}

/**
 * @summary Delete an order
 */
export const deleteOrdersOrderId = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteOrdersOrderIdUrl(orderId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteOrdersOrderIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrdersOrderId>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrdersOrderId>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['deleteOrdersOrderId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrdersOrderId>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return deleteOrdersOrderId(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteOrdersOrderIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrdersOrderId>>
>

export type DeleteOrdersOrderIdMutationError = unknown

/**
 * @summary Delete an order
 */
export const useDeleteOrdersOrderId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrdersOrderId>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrdersOrderId>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getDeleteOrdersOrderIdMutationOptions(options), queryClient)
}
export const getPatchOrdersOrderIdUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}`
}

/**
 * @summary Edit an order - anything but the three statuses that settle money
 */
export const patchOrdersOrderId = async (
  orderId: number,
  patchOrdersOrderIdBody: PatchOrdersOrderIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderFull> => {
  return customFetch<OrderFull>(getPatchOrdersOrderIdUrl(orderId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchOrdersOrderIdBody),
  })
}

export const getPatchOrdersOrderIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrdersOrderId>>,
    TError,
    { orderId: number; data: PatchOrdersOrderIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrdersOrderId>>,
  TError,
  { orderId: number; data: PatchOrdersOrderIdBody },
  TContext
> => {
  const mutationKey = ['patchOrdersOrderId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrdersOrderId>>,
    { orderId: number; data: PatchOrdersOrderIdBody }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return patchOrdersOrderId(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchOrdersOrderIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrdersOrderId>>
>
export type PatchOrdersOrderIdMutationBody = PatchOrdersOrderIdBody
export type PatchOrdersOrderIdMutationError = unknown

/**
 * @summary Edit an order - anything but the three statuses that settle money
 */
export const usePatchOrdersOrderId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrdersOrderId>>,
      TError,
      { orderId: number; data: PatchOrdersOrderIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrdersOrderId>>,
  TError,
  { orderId: number; data: PatchOrdersOrderIdBody },
  TContext
> => {
  return useMutation(getPatchOrdersOrderIdMutationOptions(options), queryClient)
}
export const getPatchOrdersOrderIdSalesChannelUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/sales-channel`
}

/**
 * @summary Move an order into a different sales channel
 */
export const patchOrdersOrderIdSalesChannel = async (
  orderId: number,
  patchOrdersOrderIdSalesChannelBody: PatchOrdersOrderIdSalesChannelBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderChannelMoved> => {
  return customFetch<OrderChannelMoved>(getPatchOrdersOrderIdSalesChannelUrl(orderId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchOrdersOrderIdSalesChannelBody),
  })
}

export const getPatchOrdersOrderIdSalesChannelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrdersOrderIdSalesChannel>>,
    TError,
    { orderId: number; data: PatchOrdersOrderIdSalesChannelBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrdersOrderIdSalesChannel>>,
  TError,
  { orderId: number; data: PatchOrdersOrderIdSalesChannelBody },
  TContext
> => {
  const mutationKey = ['patchOrdersOrderIdSalesChannel']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrdersOrderIdSalesChannel>>,
    { orderId: number; data: PatchOrdersOrderIdSalesChannelBody }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return patchOrdersOrderIdSalesChannel(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchOrdersOrderIdSalesChannelMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrdersOrderIdSalesChannel>>
>
export type PatchOrdersOrderIdSalesChannelMutationBody = PatchOrdersOrderIdSalesChannelBody
export type PatchOrdersOrderIdSalesChannelMutationError = unknown

/**
 * @summary Move an order into a different sales channel
 */
export const usePatchOrdersOrderIdSalesChannel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrdersOrderIdSalesChannel>>,
      TError,
      { orderId: number; data: PatchOrdersOrderIdSalesChannelBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrdersOrderIdSalesChannel>>,
  TError,
  { orderId: number; data: PatchOrdersOrderIdSalesChannelBody },
  TContext
> => {
  return useMutation(getPatchOrdersOrderIdSalesChannelMutationOptions(options), queryClient)
}
export const getPatchOrdersOrderIdItemsItemIdServedStatusUrl = (
  orderId: number,
  itemId: number,
) => {
  return `/api/v1/orders/${orderId}/items/${itemId}/served-status`
}

/**
 * @summary Mark one line served or unserved
 */
export const patchOrdersOrderIdItemsItemIdServedStatus = async (
  orderId: number,
  itemId: number,
  servedStatusRequest: ServedStatusRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<ServedLine> => {
  return customFetch<ServedLine>(getPatchOrdersOrderIdItemsItemIdServedStatusUrl(orderId, itemId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(servedStatusRequest),
  })
}

export const getPatchOrdersOrderIdItemsItemIdServedStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdServedStatus>>,
    TError,
    { orderId: number; itemId: number; data: ServedStatusRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdServedStatus>>,
  TError,
  { orderId: number; itemId: number; data: ServedStatusRequest },
  TContext
> => {
  const mutationKey = ['patchOrdersOrderIdItemsItemIdServedStatus']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdServedStatus>>,
    { orderId: number; itemId: number; data: ServedStatusRequest }
  > = (props) => {
    const { orderId, itemId, data } = props ?? {}

    return patchOrdersOrderIdItemsItemIdServedStatus(orderId, itemId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchOrdersOrderIdItemsItemIdServedStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdServedStatus>>
>
export type PatchOrdersOrderIdItemsItemIdServedStatusMutationBody = ServedStatusRequest
export type PatchOrdersOrderIdItemsItemIdServedStatusMutationError = unknown

/**
 * @summary Mark one line served or unserved
 */
export const usePatchOrdersOrderIdItemsItemIdServedStatus = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdServedStatus>>,
      TError,
      { orderId: number; itemId: number; data: ServedStatusRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdServedStatus>>,
  TError,
  { orderId: number; itemId: number; data: ServedStatusRequest },
  TContext
> => {
  return useMutation(
    getPatchOrdersOrderIdItemsItemIdServedStatusMutationOptions(options),
    queryClient,
  )
}
export const getPatchOrdersOrderIdItemsItemIdKitchenProgressUrl = (
  orderId: number,
  itemId: number,
) => {
  return `/api/v1/orders/${orderId}/items/${itemId}/kitchen-progress`
}

/**
 * @summary Store a cook's tap on one kitchen line
 */
export const patchOrdersOrderIdItemsItemIdKitchenProgress = async (
  orderId: number,
  itemId: number,
  kitchenProgressRequest: KitchenProgressRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<KitchenProgressLine> => {
  return customFetch<KitchenProgressLine>(
    getPatchOrdersOrderIdItemsItemIdKitchenProgressUrl(orderId, itemId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(kitchenProgressRequest),
    },
  )
}

export const getPatchOrdersOrderIdItemsItemIdKitchenProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdKitchenProgress>>,
    TError,
    { orderId: number; itemId: number; data: KitchenProgressRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdKitchenProgress>>,
  TError,
  { orderId: number; itemId: number; data: KitchenProgressRequest },
  TContext
> => {
  const mutationKey = ['patchOrdersOrderIdItemsItemIdKitchenProgress']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdKitchenProgress>>,
    { orderId: number; itemId: number; data: KitchenProgressRequest }
  > = (props) => {
    const { orderId, itemId, data } = props ?? {}

    return patchOrdersOrderIdItemsItemIdKitchenProgress(orderId, itemId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchOrdersOrderIdItemsItemIdKitchenProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdKitchenProgress>>
>
export type PatchOrdersOrderIdItemsItemIdKitchenProgressMutationBody = KitchenProgressRequest
export type PatchOrdersOrderIdItemsItemIdKitchenProgressMutationError = unknown

/**
 * @summary Store a cook's tap on one kitchen line
 */
export const usePatchOrdersOrderIdItemsItemIdKitchenProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdKitchenProgress>>,
      TError,
      { orderId: number; itemId: number; data: KitchenProgressRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrdersOrderIdItemsItemIdKitchenProgress>>,
  TError,
  { orderId: number; itemId: number; data: KitchenProgressRequest },
  TContext
> => {
  return useMutation(
    getPatchOrdersOrderIdItemsItemIdKitchenProgressMutationOptions(options),
    queryClient,
  )
}
export const getGetTripLogUrl = (params?: GetTripLogParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/trip-log?${stringifiedParams}` : `/api/v1/trip-log`
}

/**
 * @summary Delivery runs in a date range, with distance and fuel data
 */
export const getTripLog = async (
  params?: GetTripLogParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeliveryRun[]> => {
  return customFetch<DeliveryRun[]>(getGetTripLogUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetTripLogQueryKey = (params?: GetTripLogParams) => {
  return [`/api/v1/trip-log`, ...(params ? [params] : [])] as const
}

export const getGetTripLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getTripLog>>,
  TError = unknown,
>(
  params?: GetTripLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripLog>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTripLogQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTripLog>>> = ({ signal }) =>
    getTripLog(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTripLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTripLogQueryResult = NonNullable<Awaited<ReturnType<typeof getTripLog>>>
export type GetTripLogQueryError = unknown

export function useGetTripLog<TData = Awaited<ReturnType<typeof getTripLog>>, TError = unknown>(
  params: undefined | GetTripLogParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripLog>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTripLog>>,
          TError,
          Awaited<ReturnType<typeof getTripLog>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTripLog<TData = Awaited<ReturnType<typeof getTripLog>>, TError = unknown>(
  params?: GetTripLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripLog>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTripLog>>,
          TError,
          Awaited<ReturnType<typeof getTripLog>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTripLog<TData = Awaited<ReturnType<typeof getTripLog>>, TError = unknown>(
  params?: GetTripLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripLog>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delivery runs in a date range, with distance and fuel data
 */

export function useGetTripLog<TData = Awaited<ReturnType<typeof getTripLog>>, TError = unknown>(
  params?: GetTripLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripLog>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTripLogQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSalesChannelsPublicUrl = () => {
  return `/api/v1/sales-channels/public`
}

/**
 * @summary The channels a customer may order on
 */
export const getSalesChannelsPublic = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PublicSalesChannel[]> => {
  return customFetch<PublicSalesChannel[]>(getGetSalesChannelsPublicUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSalesChannelsPublicQueryKey = () => {
  return [`/api/v1/sales-channels/public`] as const
}

export const getGetSalesChannelsPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesChannelsPublic>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsPublic>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSalesChannelsPublicQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesChannelsPublic>>> = ({ signal }) =>
    getSalesChannelsPublic({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesChannelsPublic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSalesChannelsPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalesChannelsPublic>>
>
export type GetSalesChannelsPublicQueryError = unknown

export function useGetSalesChannelsPublic<
  TData = Awaited<ReturnType<typeof getSalesChannelsPublic>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsPublic>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesChannelsPublic>>,
          TError,
          Awaited<ReturnType<typeof getSalesChannelsPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesChannelsPublic<
  TData = Awaited<ReturnType<typeof getSalesChannelsPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsPublic>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesChannelsPublic>>,
          TError,
          Awaited<ReturnType<typeof getSalesChannelsPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSalesChannelsPublic<
  TData = Awaited<ReturnType<typeof getSalesChannelsPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The channels a customer may order on
 */

export function useGetSalesChannelsPublic<
  TData = Awaited<ReturnType<typeof getSalesChannelsPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSalesChannelsPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSalesChannelsPublicQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrdersOrderIdStatusLogsUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/status-logs`
}

/**
 * @summary Every sensitive status change this order went through
 */
export const getOrdersOrderIdStatusLogs = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderStatusLog[]> => {
  return customFetch<OrderStatusLog[]>(getGetOrdersOrderIdStatusLogsUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersOrderIdStatusLogsQueryKey = (orderId: number) => {
  return [`/api/v1/orders/${orderId}/status-logs`] as const
}

export const getGetOrdersOrderIdStatusLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersOrderIdStatusLogsQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>> = ({
    signal,
  }) => getOrdersOrderIdStatusLogs(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetOrdersOrderIdStatusLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>
>
export type GetOrdersOrderIdStatusLogsQueryError = unknown

export function useGetOrdersOrderIdStatusLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdStatusLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdStatusLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every sensitive status change this order went through
 */

export function useGetOrdersOrderIdStatusLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdStatusLogs>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersOrderIdStatusLogsQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrdersOrderIdEditLogsUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/edit-logs`
}

/**
 * @summary Every content edit this order went through
 */
export const getOrdersOrderIdEditLogs = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderEditLog[]> => {
  return customFetch<OrderEditLog[]>(getGetOrdersOrderIdEditLogsUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersOrderIdEditLogsQueryKey = (orderId: number) => {
  return [`/api/v1/orders/${orderId}/edit-logs`] as const
}

export const getGetOrdersOrderIdEditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersOrderIdEditLogsQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>> = ({
    signal,
  }) => getOrdersOrderIdEditLogs(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetOrdersOrderIdEditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>
>
export type GetOrdersOrderIdEditLogsQueryError = unknown

export function useGetOrdersOrderIdEditLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdEditLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdEditLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every content edit this order went through
 */

export function useGetOrdersOrderIdEditLogs<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdEditLogs>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersOrderIdEditLogsQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrdersHeatmapUrl = (params?: GetOrdersHeatmapParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/orders/heatmap?${stringifiedParams}`
    : `/api/v1/orders/heatmap`
}

/**
 * @summary Orders per weekday and hour, as a 7×24 grid
 */
export const getOrdersHeatmap = async (
  params?: GetOrdersHeatmapParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderHeatmap> => {
  return customFetch<OrderHeatmap>(getGetOrdersHeatmapUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersHeatmapQueryKey = (params?: GetOrdersHeatmapParams) => {
  return [`/api/v1/orders/heatmap`, ...(params ? [params] : [])] as const
}

export const getGetOrdersHeatmapQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersHeatmap>>,
  TError = unknown,
>(
  params?: GetOrdersHeatmapParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersHeatmap>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersHeatmapQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersHeatmap>>> = ({ signal }) =>
    getOrdersHeatmap(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrdersHeatmap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrdersHeatmapQueryResult = NonNullable<Awaited<ReturnType<typeof getOrdersHeatmap>>>
export type GetOrdersHeatmapQueryError = unknown

export function useGetOrdersHeatmap<
  TData = Awaited<ReturnType<typeof getOrdersHeatmap>>,
  TError = unknown,
>(
  params: undefined | GetOrdersHeatmapParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersHeatmap>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersHeatmap>>,
          TError,
          Awaited<ReturnType<typeof getOrdersHeatmap>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersHeatmap<
  TData = Awaited<ReturnType<typeof getOrdersHeatmap>>,
  TError = unknown,
>(
  params?: GetOrdersHeatmapParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersHeatmap>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersHeatmap>>,
          TError,
          Awaited<ReturnType<typeof getOrdersHeatmap>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersHeatmap<
  TData = Awaited<ReturnType<typeof getOrdersHeatmap>>,
  TError = unknown,
>(
  params?: GetOrdersHeatmapParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersHeatmap>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Orders per weekday and hour, as a 7×24 grid
 */

export function useGetOrdersHeatmap<
  TData = Awaited<ReturnType<typeof getOrdersHeatmap>>,
  TError = unknown,
>(
  params?: GetOrdersHeatmapParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersHeatmap>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersHeatmapQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrdersDailySummaryUrl = (params?: GetOrdersDailySummaryParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/orders/daily-summary?${stringifiedParams}`
    : `/api/v1/orders/daily-summary`
}

/**
 * @summary One day's takings, split by payment method
 */
export const getOrdersDailySummary = async (
  params?: GetOrdersDailySummaryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DailySummary> => {
  return customFetch<DailySummary>(getGetOrdersDailySummaryUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersDailySummaryQueryKey = (params?: GetOrdersDailySummaryParams) => {
  return [`/api/v1/orders/daily-summary`, ...(params ? [params] : [])] as const
}

export const getGetOrdersDailySummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersDailySummary>>,
  TError = unknown,
>(
  params?: GetOrdersDailySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersDailySummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersDailySummaryQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersDailySummary>>> = ({ signal }) =>
    getOrdersDailySummary(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrdersDailySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrdersDailySummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersDailySummary>>
>
export type GetOrdersDailySummaryQueryError = unknown

export function useGetOrdersDailySummary<
  TData = Awaited<ReturnType<typeof getOrdersDailySummary>>,
  TError = unknown,
>(
  params: undefined | GetOrdersDailySummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersDailySummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersDailySummary>>,
          TError,
          Awaited<ReturnType<typeof getOrdersDailySummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersDailySummary<
  TData = Awaited<ReturnType<typeof getOrdersDailySummary>>,
  TError = unknown,
>(
  params?: GetOrdersDailySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersDailySummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersDailySummary>>,
          TError,
          Awaited<ReturnType<typeof getOrdersDailySummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersDailySummary<
  TData = Awaited<ReturnType<typeof getOrdersDailySummary>>,
  TError = unknown,
>(
  params?: GetOrdersDailySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersDailySummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One day's takings, split by payment method
 */

export function useGetOrdersDailySummary<
  TData = Awaited<ReturnType<typeof getOrdersDailySummary>>,
  TError = unknown,
>(
  params?: GetOrdersDailySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersDailySummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersDailySummaryQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrdersAvgCompletionTimeUrl = () => {
  return `/api/v1/orders/avg-completion-time`
}

/**
 * @summary Average minutes from order to kitchen-done
 */
export const getOrdersAvgCompletionTime = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AverageCompletionTime> => {
  return customFetch<AverageCompletionTime>(getGetOrdersAvgCompletionTimeUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersAvgCompletionTimeQueryKey = () => {
  return [`/api/v1/orders/avg-completion-time`] as const
}

export const getGetOrdersAvgCompletionTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersAvgCompletionTimeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>> = ({
    signal,
  }) => getOrdersAvgCompletionTime({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrdersAvgCompletionTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>
>
export type GetOrdersAvgCompletionTimeQueryError = unknown

export function useGetOrdersAvgCompletionTime<
  TData = Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
          TError,
          Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersAvgCompletionTime<
  TData = Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
          TError,
          Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersAvgCompletionTime<
  TData = Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Average minutes from order to kitchen-done
 */

export function useGetOrdersAvgCompletionTime<
  TData = Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersAvgCompletionTime>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersAvgCompletionTimeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrderTabsIdUrl = (id: number) => {
  return `/api/v1/order-tabs/${id}`
}

/**
 * @summary One tab, with its orders and its payments
 */
export const getOrderTabsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTabDetail> => {
  return customFetch<OrderTabDetail>(getGetOrderTabsIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrderTabsIdQueryKey = (id: number) => {
  return [`/api/v1/order-tabs/${id}`] as const
}

export const getGetOrderTabsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderTabsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrderTabsIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderTabsId>>> = ({ signal }) =>
    getOrderTabsId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetOrderTabsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderTabsId>>>
export type GetOrderTabsIdQueryError = unknown

export function useGetOrderTabsId<
  TData = Awaited<ReturnType<typeof getOrderTabsId>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderTabsId>>,
          TError,
          Awaited<ReturnType<typeof getOrderTabsId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderTabsId<
  TData = Awaited<ReturnType<typeof getOrderTabsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderTabsId>>,
          TError,
          Awaited<ReturnType<typeof getOrderTabsId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderTabsId<
  TData = Awaited<ReturnType<typeof getOrderTabsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One tab, with its orders and its payments
 */

export function useGetOrderTabsId<
  TData = Awaited<ReturnType<typeof getOrderTabsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrderTabsIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrderTabsAllUrl = () => {
  return `/api/v1/order-tabs/all`
}

/**
 * @summary Every tab, open or settled
 */
export const getOrderTabsAll = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTab[]> => {
  return customFetch<OrderTab[]>(getGetOrderTabsAllUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrderTabsAllQueryKey = () => {
  return [`/api/v1/order-tabs/all`] as const
}

export const getGetOrderTabsAllQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderTabsAll>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsAll>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrderTabsAllQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderTabsAll>>> = ({ signal }) =>
    getOrderTabsAll({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderTabsAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderTabsAllQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderTabsAll>>>
export type GetOrderTabsAllQueryError = unknown

export function useGetOrderTabsAll<
  TData = Awaited<ReturnType<typeof getOrderTabsAll>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsAll>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderTabsAll>>,
          TError,
          Awaited<ReturnType<typeof getOrderTabsAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderTabsAll<
  TData = Awaited<ReturnType<typeof getOrderTabsAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsAll>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderTabsAll>>,
          TError,
          Awaited<ReturnType<typeof getOrderTabsAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderTabsAll<
  TData = Awaited<ReturnType<typeof getOrderTabsAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsAll>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every tab, open or settled
 */

export function useGetOrderTabsAll<
  TData = Awaited<ReturnType<typeof getOrderTabsAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderTabsAll>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrderTabsAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesIdCourierBalanceUrl = (id: number) => {
  return `/api/v1/employees/${id}/courier-balance`
}

/**
 * @summary What is owed between a courier and the restaurant
 */
export const getEmployeesIdCourierBalance = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierBalance> => {
  return customFetch<CourierBalance>(getGetEmployeesIdCourierBalanceUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesIdCourierBalanceQueryKey = (id: number) => {
  return [`/api/v1/employees/${id}/courier-balance`] as const
}

export const getGetEmployeesIdCourierBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesIdCourierBalanceQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>> = ({
    signal,
  }) => getEmployeesIdCourierBalance(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetEmployeesIdCourierBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>
>
export type GetEmployeesIdCourierBalanceQueryError = unknown

export function useGetEmployeesIdCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesIdCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesIdCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What is owed between a courier and the restaurant
 */

export function useGetEmployeesIdCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdCourierBalance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesIdCourierBalanceQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesMyCourierBalanceUrl = () => {
  return `/api/v1/employees/my-courier-balance`
}

/**
 * @summary What is owed between you and the restaurant
 */
export const getEmployeesMyCourierBalance = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierBalance> => {
  return customFetch<CourierBalance>(getGetEmployeesMyCourierBalanceUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesMyCourierBalanceQueryKey = () => {
  return [`/api/v1/employees/my-courier-balance`] as const
}

export const getGetEmployeesMyCourierBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesMyCourierBalanceQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>> = ({
    signal,
  }) => getEmployeesMyCourierBalance({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesMyCourierBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>
>
export type GetEmployeesMyCourierBalanceQueryError = unknown

export function useGetEmployeesMyCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What is owed between you and the restaurant
 */

export function useGetEmployeesMyCourierBalance<
  TData = Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyCourierBalance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesMyCourierBalanceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDriverPoolUrl = () => {
  return `/api/v1/driver-pool`
}

/**
 * @summary Orders waiting for a courier
 */
export const getDriverPool = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierOrder[]> => {
  return customFetch<CourierOrder[]>(getGetDriverPoolUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetDriverPoolQueryKey = () => {
  return [`/api/v1/driver-pool`] as const
}

export const getGetDriverPoolQueryOptions = <
  TData = Awaited<ReturnType<typeof getDriverPool>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPool>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDriverPoolQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverPool>>> = ({ signal }) =>
    getDriverPool({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDriverPool>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriverPoolQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverPool>>>
export type GetDriverPoolQueryError = unknown

export function useGetDriverPool<
  TData = Awaited<ReturnType<typeof getDriverPool>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPool>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverPool>>,
          TError,
          Awaited<ReturnType<typeof getDriverPool>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriverPool<
  TData = Awaited<ReturnType<typeof getDriverPool>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPool>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverPool>>,
          TError,
          Awaited<ReturnType<typeof getDriverPool>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriverPool<
  TData = Awaited<ReturnType<typeof getDriverPool>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPool>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Orders waiting for a courier
 */

export function useGetDriverPool<
  TData = Awaited<ReturnType<typeof getDriverPool>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPool>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDriverPoolQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDriverPoolMineUrl = () => {
  return `/api/v1/driver-pool/mine`
}

/**
 * @summary Your orders not yet out of the restaurant
 */
export const getDriverPoolMine = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierOrder[]> => {
  return customFetch<CourierOrder[]>(getGetDriverPoolMineUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetDriverPoolMineQueryKey = () => {
  return [`/api/v1/driver-pool/mine`] as const
}

export const getGetDriverPoolMineQueryOptions = <
  TData = Awaited<ReturnType<typeof getDriverPoolMine>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPoolMine>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDriverPoolMineQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverPoolMine>>> = ({ signal }) =>
    getDriverPoolMine({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDriverPoolMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDriverPoolMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDriverPoolMine>>
>
export type GetDriverPoolMineQueryError = unknown

export function useGetDriverPoolMine<
  TData = Awaited<ReturnType<typeof getDriverPoolMine>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPoolMine>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverPoolMine>>,
          TError,
          Awaited<ReturnType<typeof getDriverPoolMine>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriverPoolMine<
  TData = Awaited<ReturnType<typeof getDriverPoolMine>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPoolMine>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverPoolMine>>,
          TError,
          Awaited<ReturnType<typeof getDriverPoolMine>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDriverPoolMine<
  TData = Awaited<ReturnType<typeof getDriverPoolMine>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPoolMine>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Your orders not yet out of the restaurant
 */

export function useGetDriverPoolMine<
  TData = Awaited<ReturnType<typeof getDriverPoolMine>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverPoolMine>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDriverPoolMineQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDeliveryQuoteUrl = (params?: GetDeliveryQuoteParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/delivery/quote?${stringifiedParams}`
    : `/api/v1/delivery/quote`
}

/**
 * @summary What delivery to a point costs where external couriers deliver (public)
 */
export const getDeliveryQuote = async (
  params?: GetDeliveryQuoteParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeliveryQuote> => {
  return customFetch<DeliveryQuote>(getGetDeliveryQuoteUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetDeliveryQuoteQueryKey = (params?: GetDeliveryQuoteParams) => {
  return [`/api/v1/delivery/quote`, ...(params ? [params] : [])] as const
}

export const getGetDeliveryQuoteQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliveryQuote>>,
  TError = unknown,
>(
  params?: GetDeliveryQuoteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryQuote>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDeliveryQuoteQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeliveryQuote>>> = ({ signal }) =>
    getDeliveryQuote(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliveryQuote>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeliveryQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof getDeliveryQuote>>>
export type GetDeliveryQuoteQueryError = unknown

export function useGetDeliveryQuote<
  TData = Awaited<ReturnType<typeof getDeliveryQuote>>,
  TError = unknown,
>(
  params: undefined | GetDeliveryQuoteParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryQuote>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryQuote>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryQuote>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryQuote<
  TData = Awaited<ReturnType<typeof getDeliveryQuote>>,
  TError = unknown,
>(
  params?: GetDeliveryQuoteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryQuote>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryQuote>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryQuote>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryQuote<
  TData = Awaited<ReturnType<typeof getDeliveryQuote>>,
  TError = unknown,
>(
  params?: GetDeliveryQuoteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryQuote>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What delivery to a point costs where external couriers deliver (public)
 */

export function useGetDeliveryQuote<
  TData = Awaited<ReturnType<typeof getDeliveryQuote>>,
  TError = unknown,
>(
  params?: GetDeliveryQuoteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryQuote>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDeliveryQuoteQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDeliveryZonesDepotUrl = () => {
  return `/api/v1/delivery-zones/depot`
}

/**
 * @summary Where deliveries start from (public)
 */
export const getDeliveryZonesDepot = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DepotResponse> => {
  return customFetch<DepotResponse>(getGetDeliveryZonesDepotUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetDeliveryZonesDepotQueryKey = () => {
  return [`/api/v1/delivery-zones/depot`] as const
}

export const getGetDeliveryZonesDepotQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZonesDepot>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDeliveryZonesDepotQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeliveryZonesDepot>>> = ({ signal }) =>
    getDeliveryZonesDepot({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeliveryZonesDepotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliveryZonesDepot>>
>
export type GetDeliveryZonesDepotQueryError = unknown

export function useGetDeliveryZonesDepot<
  TData = Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZonesDepot>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryZonesDepot>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryZonesDepot<
  TData = Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZonesDepot>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryZonesDepot>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryZonesDepot<
  TData = Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZonesDepot>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where deliveries start from (public)
 */

export function useGetDeliveryZonesDepot<
  TData = Awaited<ReturnType<typeof getDeliveryZonesDepot>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeliveryZonesDepot>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDeliveryZonesDepotQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBlockedContactsMatchUrl = (params?: GetBlockedContactsMatchParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/blocked-contacts/match?${stringifiedParams}`
    : `/api/v1/blocked-contacts/match`
}

/**
 * @summary What the till's typed phone or e-mail matches on the blocklist
 */
export const getBlockedContactsMatch = async (
  params?: GetBlockedContactsMatchParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<BlockedContactMatch[]> => {
  return customFetch<BlockedContactMatch[]>(getGetBlockedContactsMatchUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetBlockedContactsMatchQueryKey = (params?: GetBlockedContactsMatchParams) => {
  return [`/api/v1/blocked-contacts/match`, ...(params ? [params] : [])] as const
}

export const getGetBlockedContactsMatchQueryOptions = <
  TData = Awaited<ReturnType<typeof getBlockedContactsMatch>>,
  TError = unknown,
>(
  params?: GetBlockedContactsMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlockedContactsMatch>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBlockedContactsMatchQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlockedContactsMatch>>> = ({
    signal,
  }) => getBlockedContactsMatch(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBlockedContactsMatch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBlockedContactsMatchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBlockedContactsMatch>>
>
export type GetBlockedContactsMatchQueryError = unknown

export function useGetBlockedContactsMatch<
  TData = Awaited<ReturnType<typeof getBlockedContactsMatch>>,
  TError = unknown,
>(
  params: undefined | GetBlockedContactsMatchParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlockedContactsMatch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockedContactsMatch>>,
          TError,
          Awaited<ReturnType<typeof getBlockedContactsMatch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlockedContactsMatch<
  TData = Awaited<ReturnType<typeof getBlockedContactsMatch>>,
  TError = unknown,
>(
  params?: GetBlockedContactsMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlockedContactsMatch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockedContactsMatch>>,
          TError,
          Awaited<ReturnType<typeof getBlockedContactsMatch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlockedContactsMatch<
  TData = Awaited<ReturnType<typeof getBlockedContactsMatch>>,
  TError = unknown,
>(
  params?: GetBlockedContactsMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlockedContactsMatch>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the till's typed phone or e-mail matches on the blocklist
 */

export function useGetBlockedContactsMatch<
  TData = Awaited<ReturnType<typeof getBlockedContactsMatch>>,
  TError = unknown,
>(
  params?: GetBlockedContactsMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlockedContactsMatch>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBlockedContactsMatchQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteOrdersAdminResetAllUrl = () => {
  return `/api/v1/orders/admin/reset-all`
}

/**
 * @summary Delete every order and restart numbering at one
 */
export const deleteOrdersAdminResetAll = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<OrdersReset> => {
  return customFetch<OrdersReset>(getDeleteOrdersAdminResetAllUrl(), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteOrdersAdminResetAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrdersAdminResetAll>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrdersAdminResetAll>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteOrdersAdminResetAll']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrdersAdminResetAll>>,
    void
  > = () => {
    return deleteOrdersAdminResetAll(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteOrdersAdminResetAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrdersAdminResetAll>>
>

export type DeleteOrdersAdminResetAllMutationError = unknown

/**
 * @summary Delete every order and restart numbering at one
 */
export const useDeleteOrdersAdminResetAll = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrdersAdminResetAll>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrdersAdminResetAll>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteOrdersAdminResetAllMutationOptions(options), queryClient)
}
export const getDeleteBlockedContactsIdUrl = (id: number) => {
  return `/api/v1/blocked-contacts/${id}`
}

/**
 * @summary Take a block off
 */
export const deleteBlockedContactsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteBlockedContactsIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteBlockedContactsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlockedContactsId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBlockedContactsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteBlockedContactsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBlockedContactsId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteBlockedContactsId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteBlockedContactsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBlockedContactsId>>
>

export type DeleteBlockedContactsIdMutationError = unknown

/**
 * @summary Take a block off
 */
export const useDeleteBlockedContactsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBlockedContactsId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBlockedContactsId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteBlockedContactsIdMutationOptions(options), queryClient)
}
